//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class BffClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Return the authenticated user's claims as a [{type, value}] array.
     */
    getUser(signal?: AbortSignal | undefined): Promise<any[]> {
        let url_ = this.baseUrl + "/bff/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }
}

export class BillingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Update usage count on demand
     */
    updateUsages(datasetId: number, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Billing/UpdateUsages/{datasetId}";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUsages(_response);
        });
    }

    protected processUpdateUsages(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieves the Maxio Subscription Id from a dataset
     * @param datasetId (optional) 
     */
    getMaxioSubscriptionId(datasetId: number | undefined, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Billing/GetMaxioSubscriptionId?";
        if (datasetId === null)
            throw new Error("The parameter 'datasetId' cannot be null.");
        else if (datasetId !== undefined)
            url_ += "datasetId=" + encodeURIComponent("" + datasetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaxioSubscriptionId(_response);
        });
    }

    protected processGetMaxioSubscriptionId(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get all training courses
     */
    getSubscription(subscriptionId: number, signal?: AbortSignal | undefined): Promise<BillingSubscription> {
        let url_ = this.baseUrl + "/Billing/GetSubscription/{subscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubscription(_response);
        });
    }

    protected processGetSubscription(response: AxiosResponse): Promise<BillingSubscription> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BillingSubscription.fromJS(resultData200);
            return Promise.resolve<BillingSubscription>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BillingSubscription>(null as any);
    }

    /**
     * Update Maxio Subscription Id
     * @param datasetId (optional) 
     * @param maxioSubscriptionId (optional) 
     */
    updateMaxioSubscriptionId(datasetId: number | undefined, maxioSubscriptionId: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Billing/UpdateMaxioSubscriptionId?";
        if (datasetId === null)
            throw new Error("The parameter 'datasetId' cannot be null.");
        else if (datasetId !== undefined)
            url_ += "datasetId=" + encodeURIComponent("" + datasetId) + "&";
        if (maxioSubscriptionId === null)
            throw new Error("The parameter 'maxioSubscriptionId' cannot be null.");
        else if (maxioSubscriptionId !== undefined)
            url_ += "maxioSubscriptionId=" + encodeURIComponent("" + maxioSubscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMaxioSubscriptionId(_response);
        });
    }

    protected processUpdateMaxioSubscriptionId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieves all outstanding billing events
     */
    getAllOutstandingBillingEvents(signal?: AbortSignal | undefined): Promise<BillingEvent[]> {
        let url_ = this.baseUrl + "/Billing/GetAllOutstandingBillingEvents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllOutstandingBillingEvents(_response);
        });
    }

    protected processGetAllOutstandingBillingEvents(response: AxiosResponse): Promise<BillingEvent[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillingEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BillingEvent[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BillingEvent[]>(null as any);
    }

    /**
     * Retrieves VITALS billing event
     * @param careTestResultId (optional) 
     */
    getCareBillingEvent(careTestResultId: number | undefined, signal?: AbortSignal | undefined): Promise<CareBillingEvent> {
        let url_ = this.baseUrl + "/Billing/GetCareBillingEvent?";
        if (careTestResultId === null)
            throw new Error("The parameter 'careTestResultId' cannot be null.");
        else if (careTestResultId !== undefined)
            url_ += "careTestResultId=" + encodeURIComponent("" + careTestResultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCareBillingEvent(_response);
        });
    }

    protected processGetCareBillingEvent(response: AxiosResponse): Promise<CareBillingEvent> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CareBillingEvent.fromJS(resultData200);
            return Promise.resolve<CareBillingEvent>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CareBillingEvent>(null as any);
    }

    /**
     * Retrieves CORE billing event
     * @param coreTestResultId (optional) 
     */
    getCoreBillingEvent(coreTestResultId: number | undefined, signal?: AbortSignal | undefined): Promise<CoreBillingEvent> {
        let url_ = this.baseUrl + "/Billing/GetCoreBillingEvent?";
        if (coreTestResultId === null)
            throw new Error("The parameter 'coreTestResultId' cannot be null.");
        else if (coreTestResultId !== undefined)
            url_ += "coreTestResultId=" + encodeURIComponent("" + coreTestResultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCoreBillingEvent(_response);
        });
    }

    protected processGetCoreBillingEvent(response: AxiosResponse): Promise<CoreBillingEvent> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CoreBillingEvent.fromJS(resultData200);
            return Promise.resolve<CoreBillingEvent>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CoreBillingEvent>(null as any);
    }

    /**
     * Retrieves Trip Inspection billing event
     * @param tripInspectionId (optional) 
     */
    getTripInspectionBillingEvent(tripInspectionId: number | undefined, signal?: AbortSignal | undefined): Promise<TripInspectionBillingEvent> {
        let url_ = this.baseUrl + "/Billing/GetTripInspectionBillingEvent?";
        if (tripInspectionId === null)
            throw new Error("The parameter 'tripInspectionId' cannot be null.");
        else if (tripInspectionId !== undefined)
            url_ += "tripInspectionId=" + encodeURIComponent("" + tripInspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTripInspectionBillingEvent(_response);
        });
    }

    protected processGetTripInspectionBillingEvent(response: AxiosResponse): Promise<TripInspectionBillingEvent> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TripInspectionBillingEvent.fromJS(resultData200);
            return Promise.resolve<TripInspectionBillingEvent>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripInspectionBillingEvent>(null as any);
    }

    /**
     * Removes the current Maxio Subscription Id from a dataset
     * @param datasetId (optional) 
     * @param subscriptionId (optional) 
     */
    removeMaxioSubscriptionId(datasetId: number | undefined, subscriptionId: number | undefined, signal?: AbortSignal | undefined): Promise<BillingSubscription> {
        let url_ = this.baseUrl + "/Billing?";
        if (datasetId === null)
            throw new Error("The parameter 'datasetId' cannot be null.");
        else if (datasetId !== undefined)
            url_ += "datasetId=" + encodeURIComponent("" + datasetId) + "&";
        if (subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveMaxioSubscriptionId(_response);
        });
    }

    protected processRemoveMaxioSubscriptionId(response: AxiosResponse): Promise<BillingSubscription> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BillingSubscription.fromJS(resultData200);
            return Promise.resolve<BillingSubscription>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BillingSubscription>(null as any);
    }

    /**
     * Get all datasets that are billable and do not have a MaxioSubscriptionId
     */
    getBillableDatasetsWithoutMaxioId(signal?: AbortSignal | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/internal/Billing/GetBillableDatasetsWithoutMaxioId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBillableDatasetsWithoutMaxioId(_response);
        });
    }

    protected processGetBillableDatasetsWithoutMaxioId(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] as string | undefined }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class HeartbeatClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    get(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Heartbeat";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TrainingCourseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Get all training courses
     */
    getAllTrainingCourses(signal?: AbortSignal | undefined): Promise<TrainingCourse[]> {
        let url_ = this.baseUrl + "/TrainingCourse/GetAllTrainingCourses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTrainingCourses(_response);
        });
    }

    protected processGetAllTrainingCourses(response: AxiosResponse): Promise<TrainingCourse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingCourse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TrainingCourse[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingCourse[]>(null as any);
    }

    /**
     * Get a single training course
     */
    getTrainingCourse(id: number, signal?: AbortSignal | undefined): Promise<TrainingCourse> {
        let url_ = this.baseUrl + "/TrainingCourse/GetTrainingCourse/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrainingCourse(_response);
        });
    }

    protected processGetTrainingCourse(response: AxiosResponse): Promise<TrainingCourse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrainingCourse.fromJS(resultData200);
            return Promise.resolve<TrainingCourse>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingCourse>(null as any);
    }

    getAllTrainingCoursesForUser(id: number, signal?: AbortSignal | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/TrainingCourse/GetAllTrainingCoursesForUser/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTrainingCoursesForUser(_response);
        });
    }

    protected processGetAllTrainingCoursesForUser(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Adds a training course
     */
    addTrainingCourse(trainingCourse: TrainingCourse, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/TrainingCourse/AddTrainingCourse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trainingCourse);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTrainingCourse(_response);
        });
    }

    protected processAddTrainingCourse(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    addTrainingCourseToUser(userId: number | undefined, trainingCourseIds: number[], signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/TrainingCourse/AddTrainingCoursesToUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trainingCourseIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTrainingCourseToUser(_response);
        });
    }

    protected processAddTrainingCourseToUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateTrainingCourse(id: number, updatedTrainingCourse: TrainingCourse, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/TrainingCourse/UpdateTrainingCourse/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedTrainingCourse);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTrainingCourse(_response);
        });
    }

    protected processUpdateTrainingCourse(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateUserTrainingCourses(id: number, courseIds: number[], signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/TrainingCourse/UpdateTrainingCoursesForUser/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(courseIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserTrainingCourses(_response);
        });
    }

    protected processUpdateUserTrainingCourses(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Enroll a group of users into training courses
     */
    addTrainingCoursesToUsers(organizationId: number, addUsersToCoursesViewModel: AddUsersToCourses, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/TrainingCourse/AddTrainingCoursesToUsersAsync/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addUsersToCoursesViewModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTrainingCoursesToUsers(_response);
        });
    }

    protected processAddTrainingCoursesToUsers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getOrganizationTrainingSummary(organizationId: number, signal?: AbortSignal | undefined): Promise<OrganizationTrainingSummary> {
        let url_ = this.baseUrl + "/TrainingCourse/GetOrganizationTrainingSummary/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationTrainingSummary(_response);
        });
    }

    protected processGetOrganizationTrainingSummary(response: AxiosResponse): Promise<OrganizationTrainingSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationTrainingSummary.fromJS(resultData200);
            return Promise.resolve<OrganizationTrainingSummary>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationTrainingSummary>(null as any);
    }

    getUserTrainingSummary(userId: number, signal?: AbortSignal | undefined): Promise<UserTrainingSummary> {
        let url_ = this.baseUrl + "/TrainingCourse/GetUserTrainingSummary/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserTrainingSummary(_response);
        });
    }

    protected processGetUserTrainingSummary(response: AxiosResponse): Promise<UserTrainingSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserTrainingSummary.fromJS(resultData200);
            return Promise.resolve<UserTrainingSummary>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTrainingSummary>(null as any);
    }

    /**
     * Re-sync one user's training progress from Spotlightr and re-evaluate completion. Global admin only.
    This is the manual fallback for a missed player event; there is no scheduled re-sync.
     */
    resyncUserTraining(organizationId: number, userId: number, signal?: AbortSignal | undefined): Promise<CourseSyncResult[]> {
        let url_ = this.baseUrl + "/TrainingCourse/ResyncUserTraining/{organizationId}/{userId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResyncUserTraining(_response);
        });
    }

    protected processResyncUserTraining(response: AxiosResponse): Promise<CourseSyncResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseSyncResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CourseSyncResult[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseSyncResult[]>(null as any);
    }
}

export class UsersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Bulk add user role mappings for multiple datasets.
     * @param additions This is additive only. These are the additions
     * @return true if the bulk add roles succeeds.
     */
    bulkAddRoles(organizationId: number, additions: BulkAddRoles[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/organizations/{organizationId}/Users/BulkAddRoles";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(additions);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkAddRoles(_response);
        });
    }

    protected processBulkAddRoles(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Bulk add new role mappings to users
     * @param additions The users to add, along with their role / dataset mappings
     */
    bulkAddUsers(organizationId: number, additions: BulkAddUsers, signal?: AbortSignal | undefined): Promise<{ [key: string]: boolean; }> {
        let url_ = this.baseUrl + "/organizations/{organizationId}/Users/BulkAddUsers";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(additions);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkAddUsers(_response);
        });
    }

    protected processBulkAddUsers(response: AxiosResponse): Promise<{ [key: string]: boolean; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: boolean; }>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: boolean; }>(null as any);
    }

    /**
     * Bulk activate users
     * @param activations The list of users to activate / inactivate
     */
    bulkActivateUsers(organizationId: number, activations: BulkActivateUsers, signal?: AbortSignal | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/organizations/{organizationId}/Users/BulkActivateUsers";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activations);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkActivateUsers(_response);
        });
    }

    protected processBulkActivateUsers(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }
}

export class NeurapulseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * This method updates the Neurapulse test completion state based on the provided status, webId, and nonce.
     */
    updateNeurapulseState(updateNeurapulseStateViewModel: NeurapulseUpdateState, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/public/Neurapulse/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateNeurapulseStateViewModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateNeurapulseState(_response);
        });
    }

    protected processUpdateNeurapulseState(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveNeurapulseConfiguration(organizationId: number, datasetId: number, configuration: NeurapulseConfiguration, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/clientapi/Neurapulse/{organizationId}/{datasetId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configuration);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveNeurapulseConfiguration(_response);
        });
    }

    protected processSaveNeurapulseConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getNeurapulseProjectsGET(organizationId: number, datasetId: number, signal?: AbortSignal | undefined): Promise<NeurapulseProject[]> {
        let url_ = this.baseUrl + "/clientapi/Neurapulse/projects/{organizationId}/{datasetId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNeurapulseProjectsGET(_response);
        });
    }

    protected processGetNeurapulseProjectsGET(response: AxiosResponse): Promise<NeurapulseProject[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NeurapulseProject.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NeurapulseProject[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NeurapulseProject[]>(null as any);
    }

    getNeurapulseProjectsPOST(model: NeurapulseGetProjects, signal?: AbortSignal | undefined): Promise<NeurapulseProject[]> {
        let url_ = this.baseUrl + "/clientapi/Neurapulse/projects-by-key";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNeurapulseProjectsPOST(_response);
        });
    }

    protected processGetNeurapulseProjectsPOST(response: AxiosResponse): Promise<NeurapulseProject[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NeurapulseProject.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NeurapulseProject[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NeurapulseProject[]>(null as any);
    }

    getNeurapulseProject(organizationId: number, datasetId: number, signal?: AbortSignal | undefined): Promise<NeurapulseProject> {
        let url_ = this.baseUrl + "/clientapi/Neurapulse/project/{organizationId}/{datasetId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNeurapulseProject(_response);
        });
    }

    protected processGetNeurapulseProject(response: AxiosResponse): Promise<NeurapulseProject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NeurapulseProject.fromJS(resultData200);
            return Promise.resolve<NeurapulseProject>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NeurapulseProject>(null as any);
    }

    testNeurapulseApiKey(testApiKeyViewModel: NeurapulseTestApiKey, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/clientapi/Neurapulse/validate-key";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(testApiKeyViewModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestNeurapulseApiKey(_response);
        });
    }

    protected processTestNeurapulseApiKey(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the Neurapulse magic link for a dataset
     */
    getMagicLink(organizationId: number, datasetId: number, assessmentId: number, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/clientapi/Neurapulse/{organizationId}/{datasetId}/{assessmentId}/magiclink";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMagicLink(_response);
        });
    }

    protected processGetMagicLink(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Imports test takers from Neurapulse for the specified dataset.
     * @param top100Only (optional) 
     * @param completedOnly (optional) 
     */
    importNeurapulseTestTakers(organizationId: number, datasetId: number, top100Only: boolean | undefined, completedOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<NeurapulseImportProgress[]> {
        let url_ = this.baseUrl + "/clientapi/Neurapulse/{organizationId}/{datasetId}/import-test-takers?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (top100Only === null)
            throw new Error("The parameter 'top100Only' cannot be null.");
        else if (top100Only !== undefined)
            url_ += "top100Only=" + encodeURIComponent("" + top100Only) + "&";
        if (completedOnly === null)
            throw new Error("The parameter 'completedOnly' cannot be null.");
        else if (completedOnly !== undefined)
            url_ += "completedOnly=" + encodeURIComponent("" + completedOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportNeurapulseTestTakers(_response);
        });
    }

    protected processImportNeurapulseTestTakers(response: AxiosResponse): Promise<NeurapulseImportProgress[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NeurapulseImportProgress.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NeurapulseImportProgress[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NeurapulseImportProgress[]>(null as any);
    }

    /**
     * Imports test takers from Neurapulse for the specified dataset.
     */
    importNeurapulseTestTakersByEmail(organizationId: number, datasetId: number, request: ImportNeurapulseTestTakersByEmailRequest, signal?: AbortSignal | undefined): Promise<NeurapulseImportProgress[]> {
        let url_ = this.baseUrl + "/clientapi/Neurapulse/{organizationId}/{datasetId}/import-test-takers-by-email";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportNeurapulseTestTakersByEmail(_response);
        });
    }

    protected processImportNeurapulseTestTakersByEmail(response: AxiosResponse): Promise<NeurapulseImportProgress[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NeurapulseImportProgress.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NeurapulseImportProgress[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NeurapulseImportProgress[]>(null as any);
    }

    /**
     * Retrieves a list of duplicate unprocessed clients for the specified dataset.
     */
    getDuplicateUnprocessedClients(organizationId: number, datasetId: number, signal?: AbortSignal | undefined): Promise<Client[]> {
        let url_ = this.baseUrl + "/clientapi/Neurapulse/{organizationId}/{datasetId}/get-unprocessed-duplicates";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDuplicateUnprocessedClients(_response);
        });
    }

    protected processGetDuplicateUnprocessedClients(response: AxiosResponse): Promise<Client[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Client.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Client[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Client[]>(null as any);
    }

    /**
     * Fetches test-takers for a given dataset that are not yet linked to clients.
     */
    getTestTakers(organizationId: number, datasetId: number, signal?: AbortSignal | undefined): Promise<NeurapulseTestTaker[]> {
        let url_ = this.baseUrl + "/clientapi/Neurapulse/{organizationId}/{datasetId}/test-takers";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTestTakers(_response);
        });
    }

    protected processGetTestTakers(response: AxiosResponse): Promise<NeurapulseTestTaker[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NeurapulseTestTaker.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NeurapulseTestTaker[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NeurapulseTestTaker[]>(null as any);
    }

    /**
     * Links a client and a test-taker
     * @param testTakerId (optional) 
     * @param clientId (optional) 
     */
    linkClientAndTestTaker(organizationId: number, datasetId: number, testTakerId: number | undefined, clientId: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/clientapi/Neurapulse/{organizationId}/{datasetId}/link-client-and-test-taker?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (testTakerId === null)
            throw new Error("The parameter 'testTakerId' cannot be null.");
        else if (testTakerId !== undefined)
            url_ += "testTakerId=" + encodeURIComponent("" + testTakerId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkClientAndTestTaker(_response);
        });
    }

    protected processLinkClientAndTestTaker(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Removes linkage between a client and a test-taker
     * @param clientId (optional) 
     */
    unlinkClientAndTestTaker(organizationId: number, datasetId: number, clientId: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/clientapi/Neurapulse/{organizationId}/{datasetId}/unlink-client-and-test-taker?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlinkClientAndTestTaker(_response);
        });
    }

    protected processUnlinkClientAndTestTaker(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CertificationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Update a user's certification status
     */
    updateCertification(updateCertification: UpdateCertification, signal?: AbortSignal | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/internal/Certification/UpdateCertification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateCertification);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCertification(_response);
        });
    }

    protected processUpdateCertification(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] as string | undefined }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PublishE2EClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Submit Client Assessments
     */
    publish(organizationId: number, publishedClients: PublishingClient[], signal?: AbortSignal | undefined): Promise<PublishClientResult[]> {
        let url_ = this.baseUrl + "/e2e/Publish/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(publishedClients);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublish(_response);
        });
    }

    protected processPublish(response: AxiosResponse): Promise<PublishClientResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublishClientResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublishClientResult[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublishClientResult[]>(null as any);
    }
}

export class AssessmentClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Retrieves all assessments for a given client and dataset
     */
    getAll(organizationId: number, datasetId: number, clientId: number, signal?: AbortSignal | undefined): Promise<Assessment[]> {
        let url_ = this.baseUrl + "/clientapi/Assessment/{organizationId}/{datasetId}/{clientId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<Assessment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Assessment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Assessment[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment[]>(null as any);
    }

    /**
     * Adds assessment
     * @param force (optional) 
     */
    add(organizationId: number, datasetId: number, clientId: number, assessment: Assessment, force: boolean | undefined, signal?: AbortSignal | undefined): Promise<Assessment> {
        let url_ = this.baseUrl + "/clientapi/Assessment/{organizationId}/{datasetId}/{clientId}?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (force === null)
            throw new Error("The parameter 'force' cannot be null.");
        else if (force !== undefined)
            url_ += "force=" + encodeURIComponent("" + force) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assessment);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<Assessment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Assessment.fromJS(resultData200);
            return Promise.resolve<Assessment>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment>(null as any);
    }

    /**
     * Updates assessment
     */
    update(organizationId: number, datasetId: number, clientId: number, assessment: Assessment, signal?: AbortSignal | undefined): Promise<Assessment> {
        let url_ = this.baseUrl + "/clientapi/Assessment/{organizationId}/{datasetId}/{clientId}/update";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assessment);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<Assessment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Assessment.fromJS(resultData200);
            return Promise.resolve<Assessment>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment>(null as any);
    }

    /**
     * Updates assessment custom field values
     * @param assessmentId (optional) 
     */
    updateCustomFields(datasetId: number, clientId: number, assessmentId: number | undefined, customFields: CustomFieldValue[], organizationId: string, signal?: AbortSignal | undefined): Promise<Assessment> {
        let url_ = this.baseUrl + "/clientapi/Assessment/{organizationId}/{datasetId}/{clientId}/customfields?";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (assessmentId === null)
            throw new Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customFields);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomFields(_response);
        });
    }

    protected processUpdateCustomFields(response: AxiosResponse): Promise<Assessment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Assessment.fromJS(resultData200);
            return Promise.resolve<Assessment>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment>(null as any);
    }

    /**
     * Updates assessment test links
     * @param assessmentId (optional) 
     * @param vitalsMId (optional) 
     * @param coreId (optional) 
     */
    linkTestsToAssessment(datasetId: number, clientId: number, assessmentId: number | undefined, vitalsMId: number | undefined, coreId: number | undefined, organizationId: string, signal?: AbortSignal | undefined): Promise<Assessment> {
        let url_ = this.baseUrl + "/clientapi/Assessment/{organizationId}/{datasetId}/{clientId}/updatetests?";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (assessmentId === null)
            throw new Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (vitalsMId === null)
            throw new Error("The parameter 'vitalsMId' cannot be null.");
        else if (vitalsMId !== undefined)
            url_ += "vitalsMId=" + encodeURIComponent("" + vitalsMId) + "&";
        if (coreId === null)
            throw new Error("The parameter 'coreId' cannot be null.");
        else if (coreId !== undefined)
            url_ += "coreId=" + encodeURIComponent("" + coreId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkTestsToAssessment(_response);
        });
    }

    protected processLinkTestsToAssessment(response: AxiosResponse): Promise<Assessment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Assessment.fromJS(resultData200);
            return Promise.resolve<Assessment>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment>(null as any);
    }

    /**
     * Retrieves a set of matching assessments given the criteria
     */
    getPotentialAssessmentMatches(organizationId: number, assessmentMatchCriteria: AssessmentMatchCriteria[], signal?: AbortSignal | undefined): Promise<AssessmentMatches[]> {
        let url_ = this.baseUrl + "/clientapi/Assessment/{organizationId}/matches";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assessmentMatchCriteria);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPotentialAssessmentMatches(_response);
        });
    }

    protected processGetPotentialAssessmentMatches(response: AxiosResponse): Promise<AssessmentMatches[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessmentMatches.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AssessmentMatches[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentMatches[]>(null as any);
    }

    /**
     * Retrieves an assessment result given id.
     */
    getAssessmentResultForAdmin(assessmentResultId: number, signal?: AbortSignal | undefined): Promise<Assessment> {
        let url_ = this.baseUrl + "/clientapi/Assessment/{assessmentResultId}/GetAssessmentResult";
        if (assessmentResultId === undefined || assessmentResultId === null)
            throw new Error("The parameter 'assessmentResultId' must be defined.");
        url_ = url_.replace("{assessmentResultId}", encodeURIComponent("" + assessmentResultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssessmentResultForAdmin(_response);
        });
    }

    protected processGetAssessmentResultForAdmin(response: AxiosResponse): Promise<Assessment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Assessment.fromJS(resultData200);
            return Promise.resolve<Assessment>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment>(null as any);
    }

    /**
     * Retrieves an assessment result given id.
     */
    getAssessmentResult(assessmentResultId: number, organizationId: string, datasetId: string, signal?: AbortSignal | undefined): Promise<Assessment> {
        let url_ = this.baseUrl + "/clientapi/Assessment/{organizationId}/{datasetId}/{assessmentResultId}/GetAssessmentResult";
        if (assessmentResultId === undefined || assessmentResultId === null)
            throw new Error("The parameter 'assessmentResultId' must be defined.");
        url_ = url_.replace("{assessmentResultId}", encodeURIComponent("" + assessmentResultId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssessmentResult(_response);
        });
    }

    protected processGetAssessmentResult(response: AxiosResponse): Promise<Assessment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Assessment.fromJS(resultData200);
            return Promise.resolve<Assessment>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment>(null as any);
    }

    /**
     * Retrieves a list of locked assessment ids based on the list of assessment ids provided
     */
    getLockedAssessmentIds(assessmentIdsToCheck: number[], signal?: AbortSignal | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/clientapi/Assessment/GetLockedAssessmentIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assessmentIdsToCheck);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLockedAssessmentIds(_response);
        });
    }

    protected processGetLockedAssessmentIds(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }
}

export class AuditLogClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    getAssessmentModifiedAuditLog(datasetId: number, assessmentResultId: number, signal?: AbortSignal | undefined): Promise<LastModified> {
        let url_ = this.baseUrl + "/client/AuditLog/{datasetId}/{assessmentResultId}";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (assessmentResultId === undefined || assessmentResultId === null)
            throw new Error("The parameter 'assessmentResultId' must be defined.");
        url_ = url_.replace("{assessmentResultId}", encodeURIComponent("" + assessmentResultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssessmentModifiedAuditLog(_response);
        });
    }

    protected processGetAssessmentModifiedAuditLog(response: AxiosResponse): Promise<LastModified> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LastModified.fromJS(resultData200);
            return Promise.resolve<LastModified>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LastModified>(null as any);
    }
}

export class CareConfigurationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    getAllCareConfigurations(organizationId: string, signal?: AbortSignal | undefined): Promise<CareConfiguration[]> {
        let url_ = this.baseUrl + "/clientapi/CareConfiguration/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCareConfigurations(_response);
        });
    }

    protected processGetAllCareConfigurations(response: AxiosResponse): Promise<CareConfiguration[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareConfiguration.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CareConfiguration[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CareConfiguration[]>(null as any);
    }

    getAllConfigurationVersions(careConfigurationId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<CareConfigurationVersion[]> {
        let url_ = this.baseUrl + "/clientapi/CareConfiguration/{organizationId}/{careConfigurationId}";
        if (careConfigurationId === undefined || careConfigurationId === null)
            throw new Error("The parameter 'careConfigurationId' must be defined.");
        url_ = url_.replace("{careConfigurationId}", encodeURIComponent("" + careConfigurationId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllConfigurationVersions(_response);
        });
    }

    protected processGetAllConfigurationVersions(response: AxiosResponse): Promise<CareConfigurationVersion[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareConfigurationVersion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CareConfigurationVersion[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CareConfigurationVersion[]>(null as any);
    }

    getConfigurationVersion(careConfigurationVersionId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<CareConfigurationVersion> {
        let url_ = this.baseUrl + "/clientapi/CareConfiguration/{organizationId}/version/{careConfigurationVersionId}";
        if (careConfigurationVersionId === undefined || careConfigurationVersionId === null)
            throw new Error("The parameter 'careConfigurationVersionId' must be defined.");
        url_ = url_.replace("{careConfigurationVersionId}", encodeURIComponent("" + careConfigurationVersionId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConfigurationVersion(_response);
        });
    }

    protected processGetConfigurationVersion(response: AxiosResponse): Promise<CareConfigurationVersion> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CareConfigurationVersion.fromJS(resultData200);
            return Promise.resolve<CareConfigurationVersion>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CareConfigurationVersion>(null as any);
    }
}

export class CareClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Get all Vitals-M tests for a client
     */
    getAll(organizationId: number, datasetId: number, clientId: number, signal?: AbortSignal | undefined): Promise<VitalsM[]> {
        let url_ = this.baseUrl + "/clientapi/Care/{organizationId}/{datasetId}/{clientId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<VitalsM[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VitalsM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VitalsM[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VitalsM[]>(null as any);
    }

    /**
     * Add Vitals-M test
     * @param assessmentId (optional) 
     */
    add(organizationId: number, assessmentId: number | undefined, vitalsM: VitalsM, datasetId: string, clientId: string, signal?: AbortSignal | undefined): Promise<VitalsM> {
        let url_ = this.baseUrl + "/clientapi/Care/{organizationId}/{datasetId}/{clientId}?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (assessmentId === null)
            throw new Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vitalsM);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<VitalsM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VitalsM.fromJS(resultData200);
            return Promise.resolve<VitalsM>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VitalsM>(null as any);
    }

    /**
     * Update Vitals-M test
     * @param assessmentId (optional) 
     */
    update(organizationId: number, assessmentId: number | undefined, vitalsM: VitalsM, datasetId: string, clientId: string, signal?: AbortSignal | undefined): Promise<VitalsM> {
        let url_ = this.baseUrl + "/clientapi/Care/{organizationId}/{datasetId}/{clientId}?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (assessmentId === null)
            throw new Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vitalsM);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<VitalsM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VitalsM.fromJS(resultData200);
            return Promise.resolve<VitalsM>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VitalsM>(null as any);
    }

    /**
     * Gets a specific Vitals-M test
     */
    get(organizationId: number, datasetId: number, careTestResultId: number, signal?: AbortSignal | undefined): Promise<VitalsM> {
        let url_ = this.baseUrl + "/clientapi/Care/{organizationId}/{datasetId}/VitalsM/{careTestResultId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (careTestResultId === undefined || careTestResultId === null)
            throw new Error("The parameter 'careTestResultId' must be defined.");
        url_ = url_.replace("{careTestResultId}", encodeURIComponent("" + careTestResultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<VitalsM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VitalsM.fromJS(resultData200);
            return Promise.resolve<VitalsM>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VitalsM>(null as any);
    }

    /**
     * Update Vitals-M test summary
     * @param vitalsSummary The VitalsSummaryViewModel to save
     */
    updateSummary(vitalsSummary: VitalsSummary, organizationId: string, datasetId: string, clientId: string, signal?: AbortSignal | undefined): Promise<VitalsM> {
        let url_ = this.baseUrl + "/clientapi/Care/{organizationId}/{datasetId}/{clientId}/summary";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vitalsSummary);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSummary(_response);
        });
    }

    protected processUpdateSummary(response: AxiosResponse): Promise<VitalsM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VitalsM.fromJS(resultData200);
            return Promise.resolve<VitalsM>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VitalsM>(null as any);
    }

    /**
     * Update Vitals-M comments
     * @param comments (optional) 
     */
    updateComments(careTestResultId: number, comments: string | null | undefined, organizationId: string, datasetId: string, clientId: string, signal?: AbortSignal | undefined): Promise<VitalsM> {
        let url_ = this.baseUrl + "/clientapi/Care/{organizationId}/{datasetId}/{clientId}/{careTestResultId}/comments?";
        if (careTestResultId === undefined || careTestResultId === null)
            throw new Error("The parameter 'careTestResultId' must be defined.");
        url_ = url_.replace("{careTestResultId}", encodeURIComponent("" + careTestResultId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (comments !== undefined && comments !== null)
            url_ += "comments=" + encodeURIComponent("" + comments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateComments(_response);
        });
    }

    protected processUpdateComments(response: AxiosResponse): Promise<VitalsM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VitalsM.fromJS(resultData200);
            return Promise.resolve<VitalsM>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VitalsM>(null as any);
    }

    /**
     * Update Vitals-M custom field values
     */
    updateCustomFieldValues(careTestResultId: number, customFields: CustomFieldValue[], organizationId: string, datasetId: string, clientId: string, signal?: AbortSignal | undefined): Promise<VitalsM> {
        let url_ = this.baseUrl + "/clientapi/Care/{organizationId}/{datasetId}/{clientId}/{careTestResultId}/customfieldvalues";
        if (careTestResultId === undefined || careTestResultId === null)
            throw new Error("The parameter 'careTestResultId' must be defined.");
        url_ = url_.replace("{careTestResultId}", encodeURIComponent("" + careTestResultId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customFields);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomFieldValues(_response);
        });
    }

    protected processUpdateCustomFieldValues(response: AxiosResponse): Promise<VitalsM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VitalsM.fromJS(resultData200);
            return Promise.resolve<VitalsM>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VitalsM>(null as any);
    }
}

export class ClientsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Get all clients for a dataset
     */
    getAll(organizationId: number, datasetId: number, signal?: AbortSignal | undefined): Promise<Client[]> {
        let url_ = this.baseUrl + "/clientapi/Clients/{organizationId}/{datasetId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<Client[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Client.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Client[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Client[]>(null as any);
    }

    /**
     * Adds client
     * @param force (optional) 
     */
    add(organizationId: number, datasetId: number, client: NewClient, force: boolean | undefined, signal?: AbortSignal | undefined): Promise<Client> {
        let url_ = this.baseUrl + "/clientapi/Clients/{organizationId}/{datasetId}?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (force === null)
            throw new Error("The parameter 'force' cannot be null.");
        else if (force !== undefined)
            url_ += "force=" + encodeURIComponent("" + force) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<Client> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Client.fromJS(resultData200);
            return Promise.resolve<Client>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Client>(null as any);
    }

    /**
     * Updates client
     */
    update(organizationId: number, datasetId: number, client: Client, signal?: AbortSignal | undefined): Promise<Client> {
        let url_ = this.baseUrl + "/clientapi/Clients/{organizationId}/{datasetId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<Client> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Client.fromJS(resultData200);
            return Promise.resolve<Client>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Client>(null as any);
    }

    /**
     * Returns a list of potential client matches based on dataset id
    and client information
     * @param clientMatchCriteria Clients to search
     * @return Potential matches
     */
    getPotentialClientMatches(clientMatchCriteria: ClientsMatchCriteria[], organizationId: string, signal?: AbortSignal | undefined): Promise<ClientMatch[]> {
        let url_ = this.baseUrl + "/clientapi/Clients/{organizationId}/MatchClients";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clientMatchCriteria);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPotentialClientMatches(_response);
        });
    }

    protected processGetPotentialClientMatches(response: AxiosResponse): Promise<ClientMatch[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientMatch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ClientMatch[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientMatch[]>(null as any);
    }
}

export class ClientTrainingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Retrieves all training courses for the current user
     */
    getTrainingCourses(signal?: AbortSignal | undefined): Promise<UserTrainingSummary> {
        let url_ = this.baseUrl + "/clientapi/ClientTraining/GetTrainingCourses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrainingCourses(_response);
        });
    }

    protected processGetTrainingCourses(response: AxiosResponse): Promise<UserTrainingSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserTrainingSummary.fromJS(resultData200);
            return Promise.resolve<UserTrainingSummary>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTrainingSummary>(null as any);
    }

    /**
     * Retrieves a specific training course for the current user
     */
    getTrainingCourse(trainingCourseId: number, signal?: AbortSignal | undefined): Promise<UserTrainingCourseSummary> {
        let url_ = this.baseUrl + "/clientapi/ClientTraining/GetTrainingCourse/{trainingCourseId}";
        if (trainingCourseId === undefined || trainingCourseId === null)
            throw new Error("The parameter 'trainingCourseId' must be defined.");
        url_ = url_.replace("{trainingCourseId}", encodeURIComponent("" + trainingCourseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrainingCourse(_response);
        });
    }

    protected processGetTrainingCourse(response: AxiosResponse): Promise<UserTrainingCourseSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserTrainingCourseSummary.fromJS(resultData200);
            return Promise.resolve<UserTrainingCourseSummary>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTrainingCourseSummary>(null as any);
    }

    /**
     * Record a quiz result reported by the player, then re-evaluate course completion and return the summary.
     */
    addTrainingCourseScore(trainingCourseId: number, quizId: string, request: TrainingQuizResultRequest, signal?: AbortSignal | undefined): Promise<UserTrainingCourseSummary> {
        let url_ = this.baseUrl + "/clientapi/ClientTraining/AddTrainingCourseScoreAsync/{trainingCourseId}/{quizId}";
        if (trainingCourseId === undefined || trainingCourseId === null)
            throw new Error("The parameter 'trainingCourseId' must be defined.");
        url_ = url_.replace("{trainingCourseId}", encodeURIComponent("" + trainingCourseId));
        if (quizId === undefined || quizId === null)
            throw new Error("The parameter 'quizId' must be defined.");
        url_ = url_.replace("{quizId}", encodeURIComponent("" + quizId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTrainingCourseScore(_response);
        });
    }

    protected processAddTrainingCourseScore(response: AxiosResponse): Promise<UserTrainingCourseSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserTrainingCourseSummary.fromJS(resultData200);
            return Promise.resolve<UserTrainingCourseSummary>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTrainingCourseSummary>(null as any);
    }

    updateTrainingCourseStatus(trainingCourseId: number, signal?: AbortSignal | undefined): Promise<UserTrainingCourseSummary> {
        let url_ = this.baseUrl + "/clientapi/ClientTraining/UpdateTrainingCourseStatusAsync/{trainingCourseId}";
        if (trainingCourseId === undefined || trainingCourseId === null)
            throw new Error("The parameter 'trainingCourseId' must be defined.");
        url_ = url_.replace("{trainingCourseId}", encodeURIComponent("" + trainingCourseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTrainingCourseStatus(_response);
        });
    }

    protected processUpdateTrainingCourseStatus(response: AxiosResponse): Promise<UserTrainingCourseSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserTrainingCourseSummary.fromJS(resultData200);
            return Promise.resolve<UserTrainingCourseSummary>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTrainingCourseSummary>(null as any);
    }

    /**
     * The player reported an event for a video (ended, or the learner closed it). Verify with Spotlightr,
    persist, re-evaluate course completion and return the course summary.
     */
    syncVideo(trainingCourseId: number, videoId: string, request: SyncVideoRequest, signal?: AbortSignal | undefined): Promise<UserTrainingCourseSummary> {
        let url_ = this.baseUrl + "/clientapi/ClientTraining/SyncVideo/{trainingCourseId}/{videoId}";
        if (trainingCourseId === undefined || trainingCourseId === null)
            throw new Error("The parameter 'trainingCourseId' must be defined.");
        url_ = url_.replace("{trainingCourseId}", encodeURIComponent("" + trainingCourseId));
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncVideo(_response);
        });
    }

    protected processSyncVideo(response: AxiosResponse): Promise<UserTrainingCourseSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserTrainingCourseSummary.fromJS(resultData200);
            return Promise.resolve<UserTrainingCourseSummary>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTrainingCourseSummary>(null as any);
    }
}

export class CoreClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Get all road tests for a client
     */
    getAll(organizationId: number, datasetId: number, clientId: number, signal?: AbortSignal | undefined): Promise<Core[]> {
        let url_ = this.baseUrl + "/clientapi/Core/{organizationId}/{datasetId}/{clientId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<Core[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Core.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Core[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Core[]>(null as any);
    }

    /**
     * Add CORE test
     * @param assessmentId (optional) 
     */
    add(organizationId: number, assessmentId: number | undefined, core: Core, datasetId: string, clientId: string, signal?: AbortSignal | undefined): Promise<Core> {
        let url_ = this.baseUrl + "/clientapi/Core/{organizationId}/{datasetId}/{clientId}?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (assessmentId === null)
            throw new Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(core);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<Core> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Core.fromJS(resultData200);
            return Promise.resolve<Core>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Core>(null as any);
    }

    /**
     * Update CORE test
     * @param assessmentId (optional) 
     */
    update(organizationId: number, assessmentId: number | undefined, core: Core, datasetId: string, clientId: string, signal?: AbortSignal | undefined): Promise<Core> {
        let url_ = this.baseUrl + "/clientapi/Core/{organizationId}/{datasetId}/{clientId}?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (assessmentId === null)
            throw new Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(core);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<Core> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Core.fromJS(resultData200);
            return Promise.resolve<Core>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Core>(null as any);
    }

    /**
     * Get core test
     * @param coreTestResultId (optional) 
     */
    getCore(coreTestResultId: number | undefined, organizationId: string, datasetId: string, signal?: AbortSignal | undefined): Promise<Core> {
        let url_ = this.baseUrl + "/clientapi/Core/{organizationId}/{datasetId}/core?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (coreTestResultId === null)
            throw new Error("The parameter 'coreTestResultId' cannot be null.");
        else if (coreTestResultId !== undefined)
            url_ += "coreTestResultId=" + encodeURIComponent("" + coreTestResultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCore(_response);
        });
    }

    protected processGetCore(response: AxiosResponse): Promise<Core> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Core.fromJS(resultData200);
            return Promise.resolve<Core>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Core>(null as any);
    }

    /**
     * Get route telemetry for a given CORE test
     */
    getCoreRoute(coreTestResultId: number, organizationId: string, datasetId: string, signal?: AbortSignal | undefined): Promise<CoreTestRoute[]> {
        let url_ = this.baseUrl + "/clientapi/Core/{organizationId}/{datasetId}/{coreTestResultId}/route";
        if (coreTestResultId === undefined || coreTestResultId === null)
            throw new Error("The parameter 'coreTestResultId' must be defined.");
        url_ = url_.replace("{coreTestResultId}", encodeURIComponent("" + coreTestResultId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCoreRoute(_response);
        });
    }

    protected processGetCoreRoute(response: AxiosResponse): Promise<CoreTestRoute[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoreTestRoute.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CoreTestRoute[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CoreTestRoute[]>(null as any);
    }
}

export class CustomFieldClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Retrieves all custom fields for the selected dataset
     */
    getAll(datasetId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<CustomField[]> {
        let url_ = this.baseUrl + "/clientapi/CustomField/{organizationId}/{datasetId}";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<CustomField[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomField[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomField[]>(null as any);
    }

    getAllAssessment(datasetId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<CustomField[]> {
        let url_ = this.baseUrl + "/clientapi/CustomField/{organizationId}/{datasetId}/Assessment";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAssessment(_response);
        });
    }

    protected processGetAllAssessment(response: AxiosResponse): Promise<CustomField[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomField[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomField[]>(null as any);
    }

    getAllCare(datasetId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<CustomField[]> {
        let url_ = this.baseUrl + "/clientapi/CustomField/{organizationId}/{datasetId}/Care";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCare(_response);
        });
    }

    protected processGetAllCare(response: AxiosResponse): Promise<CustomField[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomField[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomField[]>(null as any);
    }

    getAllClient(datasetId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<CustomField[]> {
        let url_ = this.baseUrl + "/clientapi/CustomField/{organizationId}/{datasetId}/Client";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllClient(_response);
        });
    }

    protected processGetAllClient(response: AxiosResponse): Promise<CustomField[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomField[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomField[]>(null as any);
    }

    getAllCore(datasetId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<CustomField[]> {
        let url_ = this.baseUrl + "/clientapi/CustomField/{organizationId}/{datasetId}/Core";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCore(_response);
        });
    }

    protected processGetAllCore(response: AxiosResponse): Promise<CustomField[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomField[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomField[]>(null as any);
    }

    getAllVitals(datasetId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<CustomField[]> {
        let url_ = this.baseUrl + "/clientapi/CustomField/{organizationId}/{datasetId}/Vitals";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllVitals(_response);
        });
    }

    protected processGetAllVitals(response: AxiosResponse): Promise<CustomField[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomField[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomField[]>(null as any);
    }
}

export class CustomFieldValueClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    getAll(datasetId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<CustomFieldValue[]> {
        let url_ = this.baseUrl + "/clientapi/CustomFieldValue/{organizationId}/{datasetId}";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<CustomFieldValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomFieldValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomFieldValue[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomFieldValue[]>(null as any);
    }

    add(newCustomFieldValue: CustomFieldValue, organizationId: string, datasetId: string, signal?: AbortSignal | undefined): Promise<CustomFieldValue> {
        let url_ = this.baseUrl + "/clientapi/CustomFieldValue/{organizationId}/{datasetId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newCustomFieldValue);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<CustomFieldValue> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomFieldValue.fromJS(resultData200);
            return Promise.resolve<CustomFieldValue>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomFieldValue>(null as any);
    }

    getAllAssessment(datasetId: number, assessmentId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<CustomFieldValue[]> {
        let url_ = this.baseUrl + "/clientapi/CustomFieldValue/{organizationId}/{datasetId}/Assessment/{assessmentId}";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAssessment(_response);
        });
    }

    protected processGetAllAssessment(response: AxiosResponse): Promise<CustomFieldValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomFieldValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomFieldValue[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomFieldValue[]>(null as any);
    }

    getAllCare(datasetId: number, careId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<CustomFieldValue[]> {
        let url_ = this.baseUrl + "/clientapi/CustomFieldValue/{organizationId}/{datasetId}/Care/{careId}";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (careId === undefined || careId === null)
            throw new Error("The parameter 'careId' must be defined.");
        url_ = url_.replace("{careId}", encodeURIComponent("" + careId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCare(_response);
        });
    }

    protected processGetAllCare(response: AxiosResponse): Promise<CustomFieldValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomFieldValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomFieldValue[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomFieldValue[]>(null as any);
    }

    getAllClient(datasetId: number, clientId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<CustomFieldValue[]> {
        let url_ = this.baseUrl + "/clientapi/CustomFieldValue/{organizationId}/{datasetId}/Client/{clientId}";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllClient(_response);
        });
    }

    protected processGetAllClient(response: AxiosResponse): Promise<CustomFieldValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomFieldValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomFieldValue[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomFieldValue[]>(null as any);
    }

    getAllCore(datasetId: number, coreId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<CustomFieldValue[]> {
        let url_ = this.baseUrl + "/clientapi/CustomFieldValue/{organizationId}/{datasetId}/Core/{coreId}";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (coreId === undefined || coreId === null)
            throw new Error("The parameter 'coreId' must be defined.");
        url_ = url_.replace("{coreId}", encodeURIComponent("" + coreId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCore(_response);
        });
    }

    protected processGetAllCore(response: AxiosResponse): Promise<CustomFieldValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomFieldValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomFieldValue[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomFieldValue[]>(null as any);
    }

    getAllVitals(datasetId: number, vitalsId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<CustomFieldValue[]> {
        let url_ = this.baseUrl + "/clientapi/CustomFieldValue/{organizationId}/{datasetId}/Vitals/{vitalsId}";
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (vitalsId === undefined || vitalsId === null)
            throw new Error("The parameter 'vitalsId' must be defined.");
        url_ = url_.replace("{vitalsId}", encodeURIComponent("" + vitalsId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllVitals(_response);
        });
    }

    protected processGetAllVitals(response: AxiosResponse): Promise<CustomFieldValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomFieldValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomFieldValue[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomFieldValue[]>(null as any);
    }

    updatePOST(newCustomFieldValue: CustomFieldValue, organizationId: string, datasetId: string, customFieldValueId: string, signal?: AbortSignal | undefined): Promise<CustomFieldValue> {
        let url_ = this.baseUrl + "/clientapi/CustomFieldValue/{organizationId}/{datasetId}/{customFieldValueId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (customFieldValueId === undefined || customFieldValueId === null)
            throw new Error("The parameter 'customFieldValueId' must be defined.");
        url_ = url_.replace("{customFieldValueId}", encodeURIComponent("" + customFieldValueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newCustomFieldValue);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePOST(_response);
        });
    }

    protected processUpdatePOST(response: AxiosResponse): Promise<CustomFieldValue> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomFieldValue.fromJS(resultData200);
            return Promise.resolve<CustomFieldValue>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomFieldValue>(null as any);
    }

    updatePUT(newCustomFieldValue: CustomFieldValue, organizationId: string, datasetId: string, customFieldValueId: string, signal?: AbortSignal | undefined): Promise<CustomFieldValue> {
        let url_ = this.baseUrl + "/clientapi/CustomFieldValue/{organizationId}/{datasetId}/{customFieldValueId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (customFieldValueId === undefined || customFieldValueId === null)
            throw new Error("The parameter 'customFieldValueId' must be defined.");
        url_ = url_.replace("{customFieldValueId}", encodeURIComponent("" + customFieldValueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newCustomFieldValue);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePUT(_response);
        });
    }

    protected processUpdatePUT(response: AxiosResponse): Promise<CustomFieldValue> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomFieldValue.fromJS(resultData200);
            return Promise.resolve<CustomFieldValue>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomFieldValue>(null as any);
    }
}

export class DatasetsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Retrieves a security trimmed list of datasets for the currently logged in user
     */
    getAll(organizationId: number, signal?: AbortSignal | undefined): Promise<Dataset[]> {
        let url_ = this.baseUrl + "/clientapi/Datasets/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<Dataset[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Dataset.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Dataset[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Dataset[]>(null as any);
    }

    /**
     * Retrieves a security trimmed list of datasets without all props filled for the currently logged in user
     */
    getAllLite(organizationId: number, signal?: AbortSignal | undefined): Promise<Dataset[]> {
        let url_ = this.baseUrl + "/clientapi/Datasets/{organizationId}/GetAllLite";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllLite(_response);
        });
    }

    protected processGetAllLite(response: AxiosResponse): Promise<Dataset[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Dataset.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Dataset[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Dataset[]>(null as any);
    }

    /**
     * Fills dataset details
     * @param datasetId (optional) 
     */
    fillDetails(organizationId: number, datasetId: number | undefined, signal?: AbortSignal | undefined): Promise<Dataset> {
        let url_ = this.baseUrl + "/clientapi/Datasets/{organizationId}/FillDetails?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === null)
            throw new Error("The parameter 'datasetId' cannot be null.");
        else if (datasetId !== undefined)
            url_ += "datasetId=" + encodeURIComponent("" + datasetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFillDetails(_response);
        });
    }

    protected processFillDetails(response: AxiosResponse): Promise<Dataset> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Dataset.fromJS(resultData200);
            return Promise.resolve<Dataset>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Dataset>(null as any);
    }

    /**
     * Retrieves the Dataset Purpose Types
     */
    getDatasetPurposeTypes(signal?: AbortSignal | undefined): Promise<DatasetPurposeType[]> {
        let url_ = this.baseUrl + "/clientapi/Datasets/GetDatasetPurposeTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDatasetPurposeTypes(_response);
        });
    }

    protected processGetDatasetPurposeTypes(response: AxiosResponse): Promise<DatasetPurposeType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DatasetPurposeType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DatasetPurposeType[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DatasetPurposeType[]>(null as any);
    }

    /**
     * Retrieves the Purpose for a given Dataset Id
     * @param datasetId (optional) 
     */
    getDatasetPurpose(datasetId: number | undefined, signal?: AbortSignal | undefined): Promise<DatasetPurposeType> {
        let url_ = this.baseUrl + "/clientapi/Datasets/GetDatasetPurpose?";
        if (datasetId === null)
            throw new Error("The parameter 'datasetId' cannot be null.");
        else if (datasetId !== undefined)
            url_ += "datasetId=" + encodeURIComponent("" + datasetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDatasetPurpose(_response);
        });
    }

    protected processGetDatasetPurpose(response: AxiosResponse): Promise<DatasetPurposeType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DatasetPurposeType.fromJS(resultData200);
            return Promise.resolve<DatasetPurposeType>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DatasetPurposeType>(null as any);
    }

    /**
     * Update dataset PII
     */
    updateDatasetPIIFields(dataset: Dataset, organizationId: string, datasetId: string, signal?: AbortSignal | undefined): Promise<Assessment> {
        let url_ = this.baseUrl + "/clientapi/Datasets/{organizationId}/{datasetId}/updatePIIFields";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === undefined || datasetId === null)
            throw new Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataset);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDatasetPIIFields(_response);
        });
    }

    protected processUpdateDatasetPIIFields(response: AxiosResponse): Promise<Assessment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Assessment.fromJS(resultData200);
            return Promise.resolve<Assessment>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Assessment>(null as any);
    }
}

export class FileManagementClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Upload a file
     * @param file (optional) 
     * @return File name in storage
     */
    uploadFile(file: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/clientapi/FileManagement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class FleetErrorClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Retrieves list of Fleet Errors for the currently logged in user
     */
    getAll(organizationId: string, signal?: AbortSignal | undefined): Promise<FleetError[]> {
        let url_ = this.baseUrl + "/clientapi/FleetError/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<FleetError[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FleetError.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FleetError[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetError[]>(null as any);
    }
}

export class ImpiricaUserClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    getImpiricaUser(userId: number, organizationId: number, signal?: AbortSignal | undefined): Promise<ImpiricaUser> {
        let url_ = this.baseUrl + "/clientapi/ImpiricaUser/{organizationId}/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImpiricaUser(_response);
        });
    }

    protected processGetImpiricaUser(response: AxiosResponse): Promise<ImpiricaUser> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImpiricaUser.fromJS(resultData200);
            return Promise.resolve<ImpiricaUser>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImpiricaUser>(null as any);
    }

    /**
     * Fetches an impirica user with given id.
     * @param userId (optional) 
     */
    getImpiricaUserForAdmin(userId: number | undefined, signal?: AbortSignal | undefined): Promise<ImpiricaUser> {
        let url_ = this.baseUrl + "/clientapi/ImpiricaUser/GetImpiricaUserForAdmin?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImpiricaUserForAdmin(_response);
        });
    }

    protected processGetImpiricaUserForAdmin(response: AxiosResponse): Promise<ImpiricaUser> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImpiricaUser.fromJS(resultData200);
            return Promise.resolve<ImpiricaUser>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImpiricaUser>(null as any);
    }

    getAll(signal?: AbortSignal | undefined): Promise<ImpiricaUser[]> {
        let url_ = this.baseUrl + "/clientapi/ImpiricaUser/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ImpiricaUser[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImpiricaUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ImpiricaUser[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImpiricaUser[]>(null as any);
    }

    getImpiricaUserDetails(userId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<ImpiricaUserDetails> {
        let url_ = this.baseUrl + "/clientapi/ImpiricaUser/{organizationId}/{userId}/details";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImpiricaUserDetails(_response);
        });
    }

    protected processGetImpiricaUserDetails(response: AxiosResponse): Promise<ImpiricaUserDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImpiricaUserDetails.fromJS(resultData200);
            return Promise.resolve<ImpiricaUserDetails>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImpiricaUserDetails>(null as any);
    }

    /**
     * Submit Information about login
     */
    publishLoginHistory(loginHistory: LoginHistory, organizationId: string, signal?: AbortSignal | undefined): Promise<LoginHistory> {
        let url_ = this.baseUrl + "/clientapi/ImpiricaUser/{organizationId}/loginhistory";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginHistory);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublishLoginHistory(_response);
        });
    }

    protected processPublishLoginHistory(response: AxiosResponse): Promise<LoginHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginHistory.fromJS(resultData200);
            return Promise.resolve<LoginHistory>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginHistory>(null as any);
    }
}

export class LanguageClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Retrieves list of Languages for the currently logged in user
     */
    getAll(organizationId: string, signal?: AbortSignal | undefined): Promise<Language[]> {
        let url_ = this.baseUrl + "/clientapi/Language/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<Language[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Language.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Language[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Language[]>(null as any);
    }
}

export class LocationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * @deprecated
     */
    snapCoreTestRouteAndErrorsToRoad(routeAndErrors: CoreRouteError, organizationId: string, signal?: AbortSignal | undefined): Promise<CoreRouteError> {
        let url_ = this.baseUrl + "/clientapi/Location/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(routeAndErrors);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSnapCoreTestRouteAndErrorsToRoad(_response);
        });
    }

    protected processSnapCoreTestRouteAndErrorsToRoad(response: AxiosResponse): Promise<CoreRouteError> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CoreRouteError.fromJS(resultData200);
            return Promise.resolve<CoreRouteError>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CoreRouteError>(null as any);
    }
}

export class MobileDiagnosticsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Submit Mobile Diagnostics
     */
    publishMobileDiagnostics(mobileDiagnostics: MobileDiagnostics, organizationId: string, signal?: AbortSignal | undefined): Promise<MobileDiagnostics> {
        let url_ = this.baseUrl + "/clientapi/MobileDiagnostics/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mobileDiagnostics);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublishMobileDiagnostics(_response);
        });
    }

    protected processPublishMobileDiagnostics(response: AxiosResponse): Promise<MobileDiagnostics> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MobileDiagnostics.fromJS(resultData200);
            return Promise.resolve<MobileDiagnostics>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileDiagnostics>(null as any);
    }
}

export class ModulesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Retrieves all Modules
     */
    getAllModules(signal?: AbortSignal | undefined): Promise<Module[]> {
        let url_ = this.baseUrl + "/clientapi/Modules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllModules(_response);
        });
    }

    protected processGetAllModules(response: AxiosResponse): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Module.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Module[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Module[]>(null as any);
    }

    /**
     * Retrieve all datasets for org and related modules
     */
    getAllDatasetModules(organizationId: number, signal?: AbortSignal | undefined): Promise<DatasetModules[]> {
        let url_ = this.baseUrl + "/clientapi/Modules/{organizationId}/GetAllDatasetModules";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDatasetModules(_response);
        });
    }

    protected processGetAllDatasetModules(response: AxiosResponse): Promise<DatasetModules[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DatasetModules.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DatasetModules[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DatasetModules[]>(null as any);
    }

    /**
     * Retrieve all modules for a given datasetId
     * @param datasetId (optional) 
     */
    getDatasetModules(organizationId: number, datasetId: number | undefined, signal?: AbortSignal | undefined): Promise<Module[]> {
        let url_ = this.baseUrl + "/clientapi/Modules/{organizationId}/GetDatasetModules?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === null)
            throw new Error("The parameter 'datasetId' cannot be null.");
        else if (datasetId !== undefined)
            url_ += "datasetId=" + encodeURIComponent("" + datasetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDatasetModules(_response);
        });
    }

    protected processGetDatasetModules(response: AxiosResponse): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Module.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Module[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Module[]>(null as any);
    }

    /**
     * Retrieve all modules for a given productId
     * @param productId (optional) 
     */
    getProductModules(organizationId: number, productId: number | undefined, signal?: AbortSignal | undefined): Promise<Module[]> {
        let url_ = this.baseUrl + "/clientapi/Modules/{organizationId}/GetProductModules?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductModules(_response);
        });
    }

    protected processGetProductModules(response: AxiosResponse): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Module.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Module[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Module[]>(null as any);
    }

    /**
     * Retrieve module security mappings for user
     * @param userId (optional) 
     */
    getAllModuleUserPermissions(organizationId: number, userId: number | undefined, signal?: AbortSignal | undefined): Promise<Vw_ModuleUserPermissions[]> {
        let url_ = this.baseUrl + "/clientapi/Modules/{organizationId}/GetAllModuleUserPermissions?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllModuleUserPermissions(_response);
        });
    }

    protected processGetAllModuleUserPermissions(response: AxiosResponse): Promise<Vw_ModuleUserPermissions[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Vw_ModuleUserPermissions.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Vw_ModuleUserPermissions[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Vw_ModuleUserPermissions[]>(null as any);
    }

    /**
     * Retrieves modules for dataset for user
     * @param datasetId (optional) 
     * @param userId (optional) 
     */
    getAllModulesForDatasetPermissions(organizationId: number, datasetId: number | undefined, userId: number | undefined, signal?: AbortSignal | undefined): Promise<Module[]> {
        let url_ = this.baseUrl + "/clientapi/Modules/{organizationId}/GetAllModulesForDatasetPermissions?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (datasetId === null)
            throw new Error("The parameter 'datasetId' cannot be null.");
        else if (datasetId !== undefined)
            url_ += "datasetId=" + encodeURIComponent("" + datasetId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllModulesForDatasetPermissions(_response);
        });
    }

    protected processGetAllModulesForDatasetPermissions(response: AxiosResponse): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Module.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Module[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Module[]>(null as any);
    }

    /**
     * Adds module dataset references
     */
    addModuleDataset(moduleDatasetXRefs: ModuleDatasetXRef[], organizationId: string, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/clientapi/Modules/{organizationId}/AddModuleDataset";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moduleDatasetXRefs);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddModuleDataset(_response);
        });
    }

    protected processAddModuleDataset(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Removes module dataset references
     */
    deleteModuleDataset(moduleDatasetXRefs: ModuleDatasetXRef[], organizationId: string, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/clientapi/Modules/{organizationId}/DeleteModuleDataset";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moduleDatasetXRefs);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteModuleDataset(_response);
        });
    }

    protected processDeleteModuleDataset(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrganizationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Retrieves a list of filtered orgs
     */
    getFilteredOrgs(filter: number[], signal?: AbortSignal | undefined): Promise<Organization[]> {
        let url_ = this.baseUrl + "/clientapi/Organization/GetFilteredOrgs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilteredOrgs(_response);
        });
    }

    protected processGetFilteredOrgs(response: AxiosResponse): Promise<Organization[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Organization.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Organization[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Organization[]>(null as any);
    }

    /**
     * Gets list of users for a given organization
     * @param organizationId (optional) 
     * @return Impirica Users
     */
    getUsersForOrg(organizationId: number | undefined, signal?: AbortSignal | undefined): Promise<ImpiricaUser[]> {
        let url_ = this.baseUrl + "/clientapi/Organization/GetUsersForOrg?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersForOrg(_response);
        });
    }

    protected processGetUsersForOrg(response: AxiosResponse): Promise<ImpiricaUser[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImpiricaUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ImpiricaUser[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImpiricaUser[]>(null as any);
    }

    /**
     * Gets a list of orgs for a given user
     * @param userId (optional) 
     * @return Organizations
     */
    getOrgsForUser(userId: number | undefined, signal?: AbortSignal | undefined): Promise<Organization[]> {
        let url_ = this.baseUrl + "/clientapi/Organization/GetOrgsForUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrgsForUser(_response);
        });
    }

    protected processGetOrgsForUser(response: AxiosResponse): Promise<Organization[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Organization.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Organization[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Organization[]>(null as any);
    }

    /**
     * Gets cross reference between orgs and users by org id
     * @param organizationId (optional) 
     * @return Cross reference table contents
     */
    getOrgXRefUsersByOrg(organizationId: number | undefined, signal?: AbortSignal | undefined): Promise<OrgXRefUser[]> {
        let url_ = this.baseUrl + "/clientapi/Organization/GetOrgXRefUsersByOrg?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrgXRefUsersByOrg(_response);
        });
    }

    protected processGetOrgXRefUsersByOrg(response: AxiosResponse): Promise<OrgXRefUser[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrgXRefUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrgXRefUser[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrgXRefUser[]>(null as any);
    }

    /**
     * Gets cross reference between orgs and users by user id
     * @param userId (optional) 
     * @return Cross reference table contents
     */
    getOrgXRefUsersByUser(userId: number | undefined, signal?: AbortSignal | undefined): Promise<OrgXRefUser[]> {
        let url_ = this.baseUrl + "/clientapi/Organization/GetOrgXRefUsersByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrgXRefUsersByUser(_response);
        });
    }

    protected processGetOrgXRefUsersByUser(response: AxiosResponse): Promise<OrgXRefUser[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrgXRefUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrgXRefUser[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrgXRefUser[]>(null as any);
    }

    /**
     * Adds org / user cross-reference
     * @return Success
     */
    addOrgXRefUser(orgXRefUsers: OrgXRefUser[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/clientapi/Organization/AddOrgXRefUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orgXRefUsers);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrgXRefUser(_response);
        });
    }

    protected processAddOrgXRefUser(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Removes org user cross-reference
     * @return Success
     */
    removeOrgXRefUser(orgXRefUsers: OrgXRefUser[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/clientapi/Organization/RemoveOrgXRefUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orgXRefUsers);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveOrgXRefUser(_response);
        });
    }

    protected processRemoveOrgXRefUser(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class PickListClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Retrieves list of PickListItems for the currently logged in user
     */
    getAll(organizationId: string, signal?: AbortSignal | undefined): Promise<PickList[]> {
        let url_ = this.baseUrl + "/clientapi/PickList/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<PickList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PickList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PickList[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PickList[]>(null as any);
    }

    /**
     * Retrieves list of PickListItems by type for the currently logged in user
     */
    getAllByType(pickListTypeId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<PickList[]> {
        let url_ = this.baseUrl + "/clientapi/PickList/{organizationId}/{pickListTypeId}";
        if (pickListTypeId === undefined || pickListTypeId === null)
            throw new Error("The parameter 'pickListTypeId' must be defined.");
        url_ = url_.replace("{pickListTypeId}", encodeURIComponent("" + pickListTypeId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllByType(_response);
        });
    }

    protected processGetAllByType(response: AxiosResponse): Promise<PickList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PickList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PickList[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PickList[]>(null as any);
    }

    /**
     * Retrieves a single PickListItem for the currently logged in user
     */
    getSingle(pickListTypeId: number, pickListId: number, organizationId: string, signal?: AbortSignal | undefined): Promise<PickList> {
        let url_ = this.baseUrl + "/clientapi/PickList/{organizationId}/{pickListTypeId}/{pickListId}";
        if (pickListTypeId === undefined || pickListTypeId === null)
            throw new Error("The parameter 'pickListTypeId' must be defined.");
        url_ = url_.replace("{pickListTypeId}", encodeURIComponent("" + pickListTypeId));
        if (pickListId === undefined || pickListId === null)
            throw new Error("The parameter 'pickListId' must be defined.");
        url_ = url_.replace("{pickListId}", encodeURIComponent("" + pickListId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingle(_response);
        });
    }

    protected processGetSingle(response: AxiosResponse): Promise<PickList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PickList.fromJS(resultData200);
            return Promise.resolve<PickList>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PickList>(null as any);
    }
}

export class ProductClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Retrieves list of Products for the currently logged in user
     */
    getAll(organizationId: string, signal?: AbortSignal | undefined): Promise<Product[]> {
        let url_ = this.baseUrl + "/clientapi/Product/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<Product[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Product[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Product[]>(null as any);
    }
}

export class PublishClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Submit Client Assessments
     */
    publish(organizationId: number, publishedClients: PublishingClient[], signal?: AbortSignal | undefined): Promise<PublishClientResult[]> {
        let url_ = this.baseUrl + "/clientapi/Publish/v2/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(publishedClients);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublish(_response);
        });
    }

    protected processPublish(response: AxiosResponse): Promise<PublishClientResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublishClientResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublishClientResult[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublishClientResult[]>(null as any);
    }
}

export class ScoringClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Score a given assessment
     * @param assessmentId (optional) 
     */
    scoreAssessment(assessmentId: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/clientapi/Scoring?";
        if (assessmentId === null)
            throw new Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScoreAssessment(_response);
        });
    }

    protected processScoreAssessment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TripInspectionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Add a full trip inspection
     */
    add(newTripInspection: TripInspection, signal?: AbortSignal | undefined): Promise<TripInspection> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newTripInspection);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<TripInspection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TripInspection.fromJS(resultData200);
            return Promise.resolve<TripInspection>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripInspection>(null as any);
    }

    /**
     * Adds a new trip inspection record
     */
    addTripInspection(newTripInspection: TripInspection, signal?: AbortSignal | undefined): Promise<TripInspection> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/AddTripInspection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newTripInspection);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTripInspection(_response);
        });
    }

    protected processAddTripInspection(response: AxiosResponse): Promise<TripInspection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TripInspection.fromJS(resultData200);
            return Promise.resolve<TripInspection>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripInspection>(null as any);
    }

    /**
     * Adds a new trip task comment
     */
    addTripTaskComments(newTripTaskComments: TripTaskComment[], signal?: AbortSignal | undefined): Promise<TripTaskComment[]> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/AddTripTaskComments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newTripTaskComments);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTripTaskComments(_response);
        });
    }

    protected processAddTripTaskComments(response: AxiosResponse): Promise<TripTaskComment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TripTaskComment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TripTaskComment[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripTaskComment[]>(null as any);
    }

    /**
     * Adds trip Observations
     */
    addTripObservations(newtripObservations: TripObservation[], signal?: AbortSignal | undefined): Promise<TripObservation[]> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/AddTripObservations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newtripObservations);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTripObservations(_response);
        });
    }

    protected processAddTripObservations(response: AxiosResponse): Promise<TripObservation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TripObservation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TripObservation[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripObservation[]>(null as any);
    }

    /**
     * Deletes trip task comments
     */
    deleteTripTaskComments(commentIds: number[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/DeleteTripTaskComments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commentIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTripTaskComments(_response);
        });
    }

    protected processDeleteTripTaskComments(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Deletes trip Observations
     */
    deleteTripObservations(observationIds: number[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/DeleteTripObservations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(observationIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTripObservations(_response);
        });
    }

    protected processDeleteTripObservations(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Retrieves all trip tasks
     */
    getAllTripTasks(signal?: AbortSignal | undefined): Promise<TripTask[]> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/GetAllTripTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTripTasks(_response);
        });
    }

    protected processGetAllTripTasks(response: AxiosResponse): Promise<TripTask[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TripTask.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TripTask[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripTask[]>(null as any);
    }

    /**
     * Retrieves trip tasks by vehicle type
     * @param vehicleSubTypeId (optional) 
     */
    getTripTasks(vehicleSubTypeId: number | undefined, signal?: AbortSignal | undefined): Promise<TripTask[]> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/GetTripTasks?";
        if (vehicleSubTypeId === null)
            throw new Error("The parameter 'vehicleSubTypeId' cannot be null.");
        else if (vehicleSubTypeId !== undefined)
            url_ += "vehicleSubTypeId=" + encodeURIComponent("" + vehicleSubTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTripTasks(_response);
        });
    }

    protected processGetTripTasks(response: AxiosResponse): Promise<TripTask[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TripTask.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TripTask[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripTask[]>(null as any);
    }

    /**
     * Retrieves links between tasks and vehicle types
     */
    getAllTripTaskVehicleTypeLinks(signal?: AbortSignal | undefined): Promise<TripTaskVehicleType[]> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/GetAllTripTaskVehicleTypeLinks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTripTaskVehicleTypeLinks(_response);
        });
    }

    protected processGetAllTripTaskVehicleTypeLinks(response: AxiosResponse): Promise<TripTaskVehicleType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TripTaskVehicleType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TripTaskVehicleType[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripTaskVehicleType[]>(null as any);
    }

    /**
     * Retrieves task comments by trip inspection id
     * @param tripInspectionId (optional) 
     */
    getTripTaskComments(tripInspectionId: number | undefined, signal?: AbortSignal | undefined): Promise<TripTaskComment[]> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/GetTripTaskComments?";
        if (tripInspectionId === null)
            throw new Error("The parameter 'tripInspectionId' cannot be null.");
        else if (tripInspectionId !== undefined)
            url_ += "tripInspectionId=" + encodeURIComponent("" + tripInspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTripTaskComments(_response);
        });
    }

    protected processGetTripTaskComments(response: AxiosResponse): Promise<TripTaskComment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TripTaskComment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TripTaskComment[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripTaskComment[]>(null as any);
    }

    /**
     * Retrieves Trip Inspection by id
     * @param tripInspectionId (optional) 
     */
    getTripInspection(tripInspectionId: number | undefined, signal?: AbortSignal | undefined): Promise<TripInspection> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/GetTripInspection?";
        if (tripInspectionId === null)
            throw new Error("The parameter 'tripInspectionId' cannot be null.");
        else if (tripInspectionId !== undefined)
            url_ += "tripInspectionId=" + encodeURIComponent("" + tripInspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTripInspection(_response);
        });
    }

    protected processGetTripInspection(response: AxiosResponse): Promise<TripInspection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TripInspection.fromJS(resultData200);
            return Promise.resolve<TripInspection>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripInspection>(null as any);
    }

    /**
     * Retrieves trip observations for given trip inspection id
     * @param tripInspectionId (optional) 
     */
    getTripObservations(tripInspectionId: number | undefined, signal?: AbortSignal | undefined): Promise<TripObservation[]> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/GetTripObservation?";
        if (tripInspectionId === null)
            throw new Error("The parameter 'tripInspectionId' cannot be null.");
        else if (tripInspectionId !== undefined)
            url_ += "tripInspectionId=" + encodeURIComponent("" + tripInspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTripObservations(_response);
        });
    }

    protected processGetTripObservations(response: AxiosResponse): Promise<TripObservation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TripObservation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TripObservation[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripObservation[]>(null as any);
    }

    /**
     * Retrieves all trip Observation types for a specified vehicle type
     * @param vehicleSubTypeId (optional) 
     */
    getAllTripObservationTypesForVehicleType(vehicleSubTypeId: number | undefined, signal?: AbortSignal | undefined): Promise<TripObservationType[]> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/GetAllTripObservationTypesForVehicleType?";
        if (vehicleSubTypeId === null)
            throw new Error("The parameter 'vehicleSubTypeId' cannot be null.");
        else if (vehicleSubTypeId !== undefined)
            url_ += "vehicleSubTypeId=" + encodeURIComponent("" + vehicleSubTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTripObservationTypesForVehicleType(_response);
        });
    }

    protected processGetAllTripObservationTypesForVehicleType(response: AxiosResponse): Promise<TripObservationType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TripObservationType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TripObservationType[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripObservationType[]>(null as any);
    }

    /**
     * Retrieves all trip Observation Vehicle type linkages
     */
    getAllTripObservationTypeVehicleTypes(signal?: AbortSignal | undefined): Promise<TripObservationTypeVehicleType[]> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/GetAllTripObservationTypeVehicleTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTripObservationTypeVehicleTypes(_response);
        });
    }

    protected processGetAllTripObservationTypeVehicleTypes(response: AxiosResponse): Promise<TripObservationTypeVehicleType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TripObservationTypeVehicleType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TripObservationTypeVehicleType[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripObservationTypeVehicleType[]>(null as any);
    }

    /**
     * Retrieves all trip Observation types
     */
    getAllTripObservationTypes(signal?: AbortSignal | undefined): Promise<TripObservationType[]> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/GetAllTripObservationTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTripObservationTypes(_response);
        });
    }

    protected processGetAllTripObservationTypes(response: AxiosResponse): Promise<TripObservationType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TripObservationType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TripObservationType[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripObservationType[]>(null as any);
    }

    /**
     * Retrieves trip Observation types for a given category and vehicle type
     * @param categoryId (optional) 
     * @param vehicleSubTypeId (optional) 
     */
    getTripObservationTypes(categoryId: number | undefined, vehicleSubTypeId: number | undefined, signal?: AbortSignal | undefined): Promise<TripObservationType[]> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/GetTripObservationTypes?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (vehicleSubTypeId === null)
            throw new Error("The parameter 'vehicleSubTypeId' cannot be null.");
        else if (vehicleSubTypeId !== undefined)
            url_ += "vehicleSubTypeId=" + encodeURIComponent("" + vehicleSubTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTripObservationTypes(_response);
        });
    }

    protected processGetTripObservationTypes(response: AxiosResponse): Promise<TripObservationType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TripObservationType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TripObservationType[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripObservationType[]>(null as any);
    }

    /**
     * Update a full Trip Inspection
     */
    update(newTripInspection: TripInspection, signal?: AbortSignal | undefined): Promise<TripInspection> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newTripInspection);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<TripInspection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TripInspection.fromJS(resultData200);
            return Promise.resolve<TripInspection>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripInspection>(null as any);
    }

    /**
     * Updates a trip task comment
     */
    updateTripTaskComment(tripTaskComment: TripTaskComment, signal?: AbortSignal | undefined): Promise<TripTaskComment> {
        let url_ = this.baseUrl + "/clientapi/TripInspection/UpdateTripTaskComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tripTaskComment);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTripTaskComment(_response);
        });
    }

    protected processUpdateTripTaskComment(response: AxiosResponse): Promise<TripTaskComment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TripTaskComment.fromJS(resultData200);
            return Promise.resolve<TripTaskComment>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TripTaskComment>(null as any);
    }
}

export class VehicleClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://host.docker.internal:55002";

    }

    /**
     * Retrieves vehicle sub types
     */
    getVehicleSubTypes(signal?: AbortSignal | undefined): Promise<VehicleSubType[]> {
        let url_ = this.baseUrl + "/clientapi/Vehicle/GetVehicleSubTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVehicleSubTypes(_response);
        });
    }

    protected processGetVehicleSubTypes(response: AxiosResponse): Promise<VehicleSubType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleSubType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VehicleSubType[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleSubType[]>(null as any);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class BillingSubscription implements IBillingSubscription {
    id!: number;
    organization?: string | undefined;
    product?: string | undefined;
    contact?: string | undefined;
    email?: string | undefined;

    constructor(data?: IBillingSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organization = _data["organization"];
            this.product = _data["product"];
            this.contact = _data["contact"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): BillingSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new BillingSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organization"] = this.organization;
        data["product"] = this.product;
        data["contact"] = this.contact;
        data["email"] = this.email;
        return data;
    }
}

export interface IBillingSubscription {
    id: number;
    organization?: string | undefined;
    product?: string | undefined;
    contact?: string | undefined;
    email?: string | undefined;
}

export class BillingEvent implements IBillingEvent {
    billingEventId!: number;
    datasetId!: number;
    billed!: boolean;
    dateCreated!: Date;
    dateBilled?: Date | undefined;

    constructor(data?: IBillingEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingEventId = _data["billingEventId"];
            this.datasetId = _data["datasetId"];
            this.billed = _data["billed"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateBilled = _data["dateBilled"] ? new Date(_data["dateBilled"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BillingEvent {
        data = typeof data === 'object' ? data : {};
        let result = new BillingEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingEventId"] = this.billingEventId;
        data["datasetId"] = this.datasetId;
        data["billed"] = this.billed;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateBilled"] = this.dateBilled ? this.dateBilled.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBillingEvent {
    billingEventId: number;
    datasetId: number;
    billed: boolean;
    dateCreated: Date;
    dateBilled?: Date | undefined;
}

export class CareBillingEvent extends BillingEvent implements ICareBillingEvent {
    careTestResultId!: number;

    constructor(data?: ICareBillingEvent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.careTestResultId = _data["careTestResultId"];
        }
    }

    static override fromJS(data: any): CareBillingEvent {
        data = typeof data === 'object' ? data : {};
        let result = new CareBillingEvent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careTestResultId"] = this.careTestResultId;
        super.toJSON(data);
        return data;
    }
}

export interface ICareBillingEvent extends IBillingEvent {
    careTestResultId: number;
}

export class CoreBillingEvent extends BillingEvent implements ICoreBillingEvent {
    coreTestResultId!: number;

    constructor(data?: ICoreBillingEvent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.coreTestResultId = _data["coreTestResultId"];
        }
    }

    static override fromJS(data: any): CoreBillingEvent {
        data = typeof data === 'object' ? data : {};
        let result = new CoreBillingEvent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coreTestResultId"] = this.coreTestResultId;
        super.toJSON(data);
        return data;
    }
}

export interface ICoreBillingEvent extends IBillingEvent {
    coreTestResultId: number;
}

export class TripInspectionBillingEvent extends BillingEvent implements ITripInspectionBillingEvent {
    tripInspectionId!: number;

    constructor(data?: ITripInspectionBillingEvent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripInspectionId = _data["tripInspectionId"];
        }
    }

    static override fromJS(data: any): TripInspectionBillingEvent {
        data = typeof data === 'object' ? data : {};
        let result = new TripInspectionBillingEvent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripInspectionId"] = this.tripInspectionId;
        super.toJSON(data);
        return data;
    }
}

export interface ITripInspectionBillingEvent extends IBillingEvent {
    tripInspectionId: number;
}

export class TrainingCourse implements ITrainingCourse {
    id!: number;
    title?: string | undefined;
    description?: string | undefined;
    galleryId?: string | undefined;
    quizId?: string | undefined;
    isActive!: boolean;
    imageUrl?: string | undefined;
    webHookUrl?: string | undefined;
    projectId?: string | undefined;
    autoEnrollAll!: boolean;
    enrollments?: TrainingCourseEnrollment[] | undefined;
    viewerId?: string | undefined;
    videoCount?: number | undefined;
    completedVideoCount?: number | undefined;
    isCompleted?: boolean | undefined;

    constructor(data?: ITrainingCourse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.galleryId = _data["galleryId"];
            this.quizId = _data["quizId"];
            this.isActive = _data["isActive"];
            this.imageUrl = _data["imageUrl"];
            this.webHookUrl = _data["webHookUrl"];
            this.projectId = _data["projectId"];
            this.autoEnrollAll = _data["autoEnrollAll"];
            if (Array.isArray(_data["enrollments"])) {
                this.enrollments = [] as any;
                for (let item of _data["enrollments"])
                    this.enrollments!.push(TrainingCourseEnrollment.fromJS(item));
            }
            this.viewerId = _data["viewerId"];
            this.videoCount = _data["videoCount"];
            this.completedVideoCount = _data["completedVideoCount"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): TrainingCourse {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["galleryId"] = this.galleryId;
        data["quizId"] = this.quizId;
        data["isActive"] = this.isActive;
        data["imageUrl"] = this.imageUrl;
        data["webHookUrl"] = this.webHookUrl;
        data["projectId"] = this.projectId;
        data["autoEnrollAll"] = this.autoEnrollAll;
        if (Array.isArray(this.enrollments)) {
            data["enrollments"] = [];
            for (let item of this.enrollments)
                data["enrollments"].push(item.toJSON());
        }
        data["viewerId"] = this.viewerId;
        data["videoCount"] = this.videoCount;
        data["completedVideoCount"] = this.completedVideoCount;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface ITrainingCourse {
    id: number;
    title?: string | undefined;
    description?: string | undefined;
    galleryId?: string | undefined;
    quizId?: string | undefined;
    isActive: boolean;
    imageUrl?: string | undefined;
    webHookUrl?: string | undefined;
    projectId?: string | undefined;
    autoEnrollAll: boolean;
    enrollments?: TrainingCourseEnrollment[] | undefined;
    viewerId?: string | undefined;
    videoCount?: number | undefined;
    completedVideoCount?: number | undefined;
    isCompleted?: boolean | undefined;
}

export class TrainingCourseEnrollment implements ITrainingCourseEnrollment {
    courseId!: number;
    productId!: number;

    constructor(data?: ITrainingCourseEnrollment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): TrainingCourseEnrollment {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseEnrollment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["productId"] = this.productId;
        return data;
    }
}

export interface ITrainingCourseEnrollment {
    courseId: number;
    productId: number;
}

export class AddUsersToCourses implements IAddUsersToCourses {
    userIds?: number[] | undefined;
    courseIds?: number[] | undefined;

    constructor(data?: IAddUsersToCourses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["courseIds"])) {
                this.courseIds = [] as any;
                for (let item of _data["courseIds"])
                    this.courseIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AddUsersToCourses {
        data = typeof data === 'object' ? data : {};
        let result = new AddUsersToCourses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.courseIds)) {
            data["courseIds"] = [];
            for (let item of this.courseIds)
                data["courseIds"].push(item);
        }
        return data;
    }
}

export interface IAddUsersToCourses {
    userIds?: number[] | undefined;
    courseIds?: number[] | undefined;
}

export class OrganizationTrainingSummary implements IOrganizationTrainingSummary {
    users?: OrganizationUserTrainingSummary[] | undefined;

    constructor(data?: IOrganizationTrainingSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(OrganizationUserTrainingSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationTrainingSummary {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationTrainingSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationTrainingSummary {
    users?: OrganizationUserTrainingSummary[] | undefined;
}

export class OrganizationUserTrainingSummary implements IOrganizationUserTrainingSummary {
    userId!: number;
    name?: string | undefined;
    isActive!: boolean;
    courses?: OrganizationUserTrainingCourseSummary[] | undefined;

    constructor(data?: IOrganizationUserTrainingSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(OrganizationUserTrainingCourseSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationUserTrainingSummary {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUserTrainingSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationUserTrainingSummary {
    userId: number;
    name?: string | undefined;
    isActive: boolean;
    courses?: OrganizationUserTrainingCourseSummary[] | undefined;
}

export class OrganizationUserTrainingCourseSummary implements IOrganizationUserTrainingCourseSummary {
    id!: number;
    title?: string | undefined;
    description?: string | undefined;
    quizComplete?: boolean | undefined;
    courseComplete!: boolean;

    constructor(data?: IOrganizationUserTrainingCourseSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.quizComplete = _data["quizComplete"];
            this.courseComplete = _data["courseComplete"];
        }
    }

    static fromJS(data: any): OrganizationUserTrainingCourseSummary {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUserTrainingCourseSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["quizComplete"] = this.quizComplete;
        data["courseComplete"] = this.courseComplete;
        return data;
    }
}

export interface IOrganizationUserTrainingCourseSummary {
    id: number;
    title?: string | undefined;
    description?: string | undefined;
    quizComplete?: boolean | undefined;
    courseComplete: boolean;
}

export class UserTrainingSummary implements IUserTrainingSummary {
    courses?: UserTrainingCourseSummary[] | undefined;

    constructor(data?: IUserTrainingSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(UserTrainingCourseSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserTrainingSummary {
        data = typeof data === 'object' ? data : {};
        let result = new UserTrainingSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserTrainingSummary {
    courses?: UserTrainingCourseSummary[] | undefined;
}

export class UserTrainingCourseSummary implements IUserTrainingCourseSummary {
    courseId!: number;
    title?: string | undefined;
    description?: string | undefined;
    projectId?: string | undefined;
    galleryId?: string | undefined;
    galleryUrl?: string | undefined;
    quizId?: string | undefined;
    quizUrl?: string | undefined;
    quizComplete?: boolean | undefined;
    courseComplete!: boolean;
    imageUrl?: string | undefined;
    completedVideos!: number;
    totalVideos!: number;
    sections?: UserTrainingCourseSectionSummary[] | undefined;

    constructor(data?: IUserTrainingCourseSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.projectId = _data["projectId"];
            this.galleryId = _data["galleryId"];
            this.galleryUrl = _data["galleryUrl"];
            this.quizId = _data["quizId"];
            this.quizUrl = _data["quizUrl"];
            this.quizComplete = _data["quizComplete"];
            this.courseComplete = _data["courseComplete"];
            this.imageUrl = _data["imageUrl"];
            this.completedVideos = _data["completedVideos"];
            this.totalVideos = _data["totalVideos"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(UserTrainingCourseSectionSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserTrainingCourseSummary {
        data = typeof data === 'object' ? data : {};
        let result = new UserTrainingCourseSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        data["galleryId"] = this.galleryId;
        data["galleryUrl"] = this.galleryUrl;
        data["quizId"] = this.quizId;
        data["quizUrl"] = this.quizUrl;
        data["quizComplete"] = this.quizComplete;
        data["courseComplete"] = this.courseComplete;
        data["imageUrl"] = this.imageUrl;
        data["completedVideos"] = this.completedVideos;
        data["totalVideos"] = this.totalVideos;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserTrainingCourseSummary {
    courseId: number;
    title?: string | undefined;
    description?: string | undefined;
    projectId?: string | undefined;
    galleryId?: string | undefined;
    galleryUrl?: string | undefined;
    quizId?: string | undefined;
    quizUrl?: string | undefined;
    quizComplete?: boolean | undefined;
    courseComplete: boolean;
    imageUrl?: string | undefined;
    completedVideos: number;
    totalVideos: number;
    sections?: UserTrainingCourseSectionSummary[] | undefined;
}

export class UserTrainingCourseSectionSummary implements IUserTrainingCourseSectionSummary {
    name?: string | undefined;
    type!: TrainingGallerySectionType;
    html?: string | undefined;
    videos?: UserTrainingCourseVideoSummary[] | undefined;

    constructor(data?: IUserTrainingCourseSectionSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.html = _data["html"];
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(UserTrainingCourseVideoSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserTrainingCourseSectionSummary {
        data = typeof data === 'object' ? data : {};
        let result = new UserTrainingCourseSectionSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["html"] = this.html;
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserTrainingCourseSectionSummary {
    name?: string | undefined;
    type: TrainingGallerySectionType;
    html?: string | undefined;
    videos?: UserTrainingCourseVideoSummary[] | undefined;
}

export enum TrainingGallerySectionType {
    Html = 0,
    Video = 1,
    IFrame = 2,
}

export class UserTrainingCourseVideoSummary implements IUserTrainingCourseVideoSummary {
    name?: string | undefined;
    percentWatched!: number;
    complete!: boolean;
    id?: string | undefined;
    remaining!: number;
    duration!: number;
    videoUrl?: string | undefined;
    thumbnail?: string | undefined;

    constructor(data?: IUserTrainingCourseVideoSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.percentWatched = _data["percentWatched"];
            this.complete = _data["complete"];
            this.id = _data["id"];
            this.remaining = _data["remaining"];
            this.duration = _data["duration"];
            this.videoUrl = _data["videoUrl"];
            this.thumbnail = _data["thumbnail"];
        }
    }

    static fromJS(data: any): UserTrainingCourseVideoSummary {
        data = typeof data === 'object' ? data : {};
        let result = new UserTrainingCourseVideoSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["percentWatched"] = this.percentWatched;
        data["complete"] = this.complete;
        data["id"] = this.id;
        data["remaining"] = this.remaining;
        data["duration"] = this.duration;
        data["videoUrl"] = this.videoUrl;
        data["thumbnail"] = this.thumbnail;
        return data;
    }
}

export interface IUserTrainingCourseVideoSummary {
    name?: string | undefined;
    percentWatched: number;
    complete: boolean;
    id?: string | undefined;
    remaining: number;
    duration: number;
    videoUrl?: string | undefined;
    thumbnail?: string | undefined;
}

export class CourseSyncResult implements ICourseSyncResult {
    courseId!: number;
    videosSynced!: number;
    videosFailed!: number;
    courseComplete!: boolean;

    constructor(data?: ICourseSyncResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.videosSynced = _data["videosSynced"];
            this.videosFailed = _data["videosFailed"];
            this.courseComplete = _data["courseComplete"];
        }
    }

    static fromJS(data: any): CourseSyncResult {
        data = typeof data === 'object' ? data : {};
        let result = new CourseSyncResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["videosSynced"] = this.videosSynced;
        data["videosFailed"] = this.videosFailed;
        data["courseComplete"] = this.courseComplete;
        return data;
    }
}

export interface ICourseSyncResult {
    courseId: number;
    videosSynced: number;
    videosFailed: number;
    courseComplete: boolean;
}

export class BulkAddRoles implements IBulkAddRoles {
    userId!: number;
    datasetId!: number;
    roleId!: number;

    constructor(data?: IBulkAddRoles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.datasetId = _data["datasetId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): BulkAddRoles {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAddRoles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["datasetId"] = this.datasetId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IBulkAddRoles {
    userId: number;
    datasetId: number;
    roleId: number;
}

export class BulkAddUsers implements IBulkAddUsers {
    roleMappings?: BulkAddUsersRoleMappings[] | undefined;
    users?: BulkAddUsersUser[] | undefined;
    certifications?: BulkAddUsersCertMappings | undefined;
    courseIds?: number[] | undefined;
    generalRoleIds?: number[] | undefined;
    exceleRATEUser!: boolean;
    driveABLEUser!: boolean;

    constructor(data?: IBulkAddUsers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roleMappings"])) {
                this.roleMappings = [] as any;
                for (let item of _data["roleMappings"])
                    this.roleMappings!.push(BulkAddUsersRoleMappings.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(BulkAddUsersUser.fromJS(item));
            }
            this.certifications = _data["certifications"] ? BulkAddUsersCertMappings.fromJS(_data["certifications"]) : <any>undefined;
            if (Array.isArray(_data["courseIds"])) {
                this.courseIds = [] as any;
                for (let item of _data["courseIds"])
                    this.courseIds!.push(item);
            }
            if (Array.isArray(_data["generalRoleIds"])) {
                this.generalRoleIds = [] as any;
                for (let item of _data["generalRoleIds"])
                    this.generalRoleIds!.push(item);
            }
            this.exceleRATEUser = _data["exceleRATEUser"];
            this.driveABLEUser = _data["driveABLEUser"];
        }
    }

    static fromJS(data: any): BulkAddUsers {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAddUsers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleMappings)) {
            data["roleMappings"] = [];
            for (let item of this.roleMappings)
                data["roleMappings"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["certifications"] = this.certifications ? this.certifications.toJSON() : <any>undefined;
        if (Array.isArray(this.courseIds)) {
            data["courseIds"] = [];
            for (let item of this.courseIds)
                data["courseIds"].push(item);
        }
        if (Array.isArray(this.generalRoleIds)) {
            data["generalRoleIds"] = [];
            for (let item of this.generalRoleIds)
                data["generalRoleIds"].push(item);
        }
        data["exceleRATEUser"] = this.exceleRATEUser;
        data["driveABLEUser"] = this.driveABLEUser;
        return data;
    }
}

export interface IBulkAddUsers {
    roleMappings?: BulkAddUsersRoleMappings[] | undefined;
    users?: BulkAddUsersUser[] | undefined;
    certifications?: BulkAddUsersCertMappings | undefined;
    courseIds?: number[] | undefined;
    generalRoleIds?: number[] | undefined;
    exceleRATEUser: boolean;
    driveABLEUser: boolean;
}

export class BulkAddUsersRoleMappings implements IBulkAddUsersRoleMappings {
    datasetId!: number;
    roleId!: number;

    constructor(data?: IBulkAddUsersRoleMappings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datasetId = _data["datasetId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): BulkAddUsersRoleMappings {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAddUsersRoleMappings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasetId"] = this.datasetId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IBulkAddUsersRoleMappings {
    datasetId: number;
    roleId: number;
}

export class BulkAddUsersUser implements IBulkAddUsersUser {
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IBulkAddUsersUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): BulkAddUsersUser {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAddUsersUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IBulkAddUsersUser {
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
}

export class BulkAddUsersCertMappings implements IBulkAddUsersCertMappings {
    coreCertified?: CertificationType | undefined;
    vitalsMCertified?: CertificationType | undefined;
    dcatCertified?: CertificationType | undefined;
    doreCertified?: CertificationType | undefined;

    constructor(data?: IBulkAddUsersCertMappings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coreCertified = _data["coreCertified"];
            this.vitalsMCertified = _data["vitalsMCertified"];
            this.dcatCertified = _data["dcatCertified"];
            this.doreCertified = _data["doreCertified"];
        }
    }

    static fromJS(data: any): BulkAddUsersCertMappings {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAddUsersCertMappings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coreCertified"] = this.coreCertified;
        data["vitalsMCertified"] = this.vitalsMCertified;
        data["dcatCertified"] = this.dcatCertified;
        data["doreCertified"] = this.doreCertified;
        return data;
    }
}

export interface IBulkAddUsersCertMappings {
    coreCertified?: CertificationType | undefined;
    vitalsMCertified?: CertificationType | undefined;
    dcatCertified?: CertificationType | undefined;
    doreCertified?: CertificationType | undefined;
}

export enum CertificationType {
    NotCertified = 21,
    Trainee = 22,
    Certified = 24,
}

export class BulkActivateUsers implements IBulkActivateUsers {
    isActive!: boolean;
    userIds!: number[];

    constructor(data?: IBulkActivateUsers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BulkActivateUsers {
        data = typeof data === 'object' ? data : {};
        let result = new BulkActivateUsers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }
}

export interface IBulkActivateUsers {
    isActive: boolean;
    userIds: number[];
}

export class NeurapulseUpdateState implements INeurapulseUpdateState {
    webId?: string | undefined;
    nonce?: string | undefined;

    constructor(data?: INeurapulseUpdateState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webId = _data["webId"];
            this.nonce = _data["nonce"];
        }
    }

    static fromJS(data: any): NeurapulseUpdateState {
        data = typeof data === 'object' ? data : {};
        let result = new NeurapulseUpdateState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webId"] = this.webId;
        data["nonce"] = this.nonce;
        return data;
    }
}

export interface INeurapulseUpdateState {
    webId?: string | undefined;
    nonce?: string | undefined;
}

export class UpdateCertification implements IUpdateCertification {
    email?: string | undefined;
    certificationType!: ScoringPlatformType;
    certificationValue!: CertificationType2;

    constructor(data?: IUpdateCertification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.certificationType = _data["certificationType"];
            this.certificationValue = _data["certificationValue"];
        }
    }

    static fromJS(data: any): UpdateCertification {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCertification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["certificationType"] = this.certificationType;
        data["certificationValue"] = this.certificationValue;
        return data;
    }
}

export interface IUpdateCertification {
    email?: string | undefined;
    certificationType: ScoringPlatformType;
    certificationValue: CertificationType2;
}

export enum ScoringPlatformType {
    Care = "care",
    Darwin = "darwin",
    DCAT = "dcat",
    Core = "core",
    Excelerate = "excelerate",
    DriveABLE = "driveable",
    Dore = "dore",
}

export enum CertificationType2 {
    NotCertified = "NotCertified",
    Trainee = "Trainee",
    Certified = "Certified",
}

export class PublishClientResult implements IPublishClientResult {
    id!: number;
    originalId?: number | undefined;
    clientCode?: string | undefined;
    assessments?: PublishAssessmentResult[] | undefined;

    constructor(data?: IPublishClientResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originalId = _data["originalId"];
            this.clientCode = _data["clientCode"];
            if (Array.isArray(_data["assessments"])) {
                this.assessments = [] as any;
                for (let item of _data["assessments"])
                    this.assessments!.push(PublishAssessmentResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PublishClientResult {
        data = typeof data === 'object' ? data : {};
        let result = new PublishClientResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalId"] = this.originalId;
        data["clientCode"] = this.clientCode;
        if (Array.isArray(this.assessments)) {
            data["assessments"] = [];
            for (let item of this.assessments)
                data["assessments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPublishClientResult {
    id: number;
    originalId?: number | undefined;
    clientCode?: string | undefined;
    assessments?: PublishAssessmentResult[] | undefined;
}

export class PublishAssessmentResult implements IPublishAssessmentResult {
    id!: number;
    originalId?: number | undefined;
    webId?: string | undefined;
    vitalsMTest?: PublishVitalsResult | undefined;
    coreTest?: PublishCoreResult | undefined;

    constructor(data?: IPublishAssessmentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originalId = _data["originalId"];
            this.webId = _data["webId"];
            this.vitalsMTest = _data["vitalsMTest"] ? PublishVitalsResult.fromJS(_data["vitalsMTest"]) : <any>undefined;
            this.coreTest = _data["coreTest"] ? PublishCoreResult.fromJS(_data["coreTest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PublishAssessmentResult {
        data = typeof data === 'object' ? data : {};
        let result = new PublishAssessmentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalId"] = this.originalId;
        data["webId"] = this.webId;
        data["vitalsMTest"] = this.vitalsMTest ? this.vitalsMTest.toJSON() : <any>undefined;
        data["coreTest"] = this.coreTest ? this.coreTest.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPublishAssessmentResult {
    id: number;
    originalId?: number | undefined;
    webId?: string | undefined;
    vitalsMTest?: PublishVitalsResult | undefined;
    coreTest?: PublishCoreResult | undefined;
}

export class PublishVitalsResult implements IPublishVitalsResult {
    id!: number;
    originalId?: number | undefined;

    constructor(data?: IPublishVitalsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originalId = _data["originalId"];
        }
    }

    static fromJS(data: any): PublishVitalsResult {
        data = typeof data === 'object' ? data : {};
        let result = new PublishVitalsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalId"] = this.originalId;
        return data;
    }
}

export interface IPublishVitalsResult {
    id: number;
    originalId?: number | undefined;
}

export class PublishCoreResult implements IPublishCoreResult {
    id!: number;
    originalId?: number | undefined;

    constructor(data?: IPublishCoreResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originalId = _data["originalId"];
        }
    }

    static fromJS(data: any): PublishCoreResult {
        data = typeof data === 'object' ? data : {};
        let result = new PublishCoreResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalId"] = this.originalId;
        return data;
    }
}

export interface IPublishCoreResult {
    id: number;
    originalId?: number | undefined;
}

export class NewClient implements INewClient {
    originalId?: number | undefined;
    neurapulseProjectEntryId?: number | undefined;
    birthYear!: number;
    birthMonth?: number | undefined;
    birthDay?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    consent!: boolean;
    consentInitials?: string | undefined;
    email?: string | undefined;
    employeeId?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    force?: boolean | undefined;
    isDirty?: boolean | undefined;
    redacted!: boolean;
    name?: string | undefined;
    customFieldValues?: CustomFieldValue[] | undefined;
    clientDatasets?: ClientXrefDatasets[] | undefined;

    constructor(data?: INewClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalId = _data["originalId"];
            this.neurapulseProjectEntryId = _data["neurapulseProjectEntryId"];
            this.birthYear = _data["birthYear"];
            this.birthMonth = _data["birthMonth"];
            this.birthDay = _data["birthDay"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.consent = _data["consent"];
            this.consentInitials = _data["consentInitials"];
            this.email = _data["email"];
            this.employeeId = _data["employeeId"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.force = _data["force"];
            this.isDirty = _data["isDirty"];
            this.redacted = _data["redacted"];
            this.name = _data["name"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValue.fromJS(item));
            }
            if (Array.isArray(_data["clientDatasets"])) {
                this.clientDatasets = [] as any;
                for (let item of _data["clientDatasets"])
                    this.clientDatasets!.push(ClientXrefDatasets.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewClient {
        data = typeof data === 'object' ? data : {};
        let result = new NewClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalId"] = this.originalId;
        data["neurapulseProjectEntryId"] = this.neurapulseProjectEntryId;
        data["birthYear"] = this.birthYear;
        data["birthMonth"] = this.birthMonth;
        data["birthDay"] = this.birthDay;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["consent"] = this.consent;
        data["consentInitials"] = this.consentInitials;
        data["email"] = this.email;
        data["employeeId"] = this.employeeId;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["force"] = this.force;
        data["isDirty"] = this.isDirty;
        data["redacted"] = this.redacted;
        data["name"] = this.name;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        if (Array.isArray(this.clientDatasets)) {
            data["clientDatasets"] = [];
            for (let item of this.clientDatasets)
                data["clientDatasets"].push(item.toJSON());
        }
        return data;
    }
}

export interface INewClient {
    originalId?: number | undefined;
    neurapulseProjectEntryId?: number | undefined;
    birthYear: number;
    birthMonth?: number | undefined;
    birthDay?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    consent: boolean;
    consentInitials?: string | undefined;
    email?: string | undefined;
    employeeId?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    force?: boolean | undefined;
    isDirty?: boolean | undefined;
    redacted: boolean;
    name?: string | undefined;
    customFieldValues?: CustomFieldValue[] | undefined;
    clientDatasets?: ClientXrefDatasets[] | undefined;
}

export class Client extends NewClient implements IClient {
    id!: number;
    clientCode?: string | undefined;
    datasetId!: number;
    createdDate?: Date | undefined;
    lastModifiedDate?: Date | undefined;
    name?: string | undefined;

    constructor(data?: IClient) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.clientCode = _data["clientCode"];
            this.datasetId = _data["datasetId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static override fromJS(data: any): Client {
        data = typeof data === 'object' ? data : {};
        let result = new Client();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientCode"] = this.clientCode;
        data["datasetId"] = this.datasetId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface IClient extends INewClient {
    id: number;
    clientCode?: string | undefined;
    datasetId: number;
    createdDate?: Date | undefined;
    lastModifiedDate?: Date | undefined;
    name?: string | undefined;
}

export class PublishingClient extends Client implements IPublishingClient {
    assessments?: Assessment[] | undefined;

    constructor(data?: IPublishingClient) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["assessments"])) {
                this.assessments = [] as any;
                for (let item of _data["assessments"])
                    this.assessments!.push(Assessment.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PublishingClient {
        data = typeof data === 'object' ? data : {};
        let result = new PublishingClient();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assessments)) {
            data["assessments"] = [];
            for (let item of this.assessments)
                data["assessments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPublishingClient extends IClient {
    assessments?: Assessment[] | undefined;
}

export class Assessment implements IAssessment {
    id!: number;
    originalId!: number;
    clientId!: number;
    dateCreated?: Date | undefined;
    dateModified?: Date | undefined;
    dateCompleted?: Date | undefined;
    coreTestResultId?: number | undefined;
    coreTest?: Core | undefined;
    careTestResultId?: number | undefined;
    careTest?: VitalsM | undefined;
    tripInspection?: TripInspection | undefined;
    vitalsTestResultId?: number | undefined;
    vitalsScore?: number | undefined;
    excelerateScore?: number | undefined;
    cognitiveErrorsTotal?: number | undefined;
    vitalsPremiumBenefit?: number | undefined;
    trainableErrorsTotal?: number | undefined;
    skillsAppraisalTotal?: number | undefined;
    hasHazardousErrors?: boolean | undefined;
    coreAborted?: boolean | undefined;
    vitalsStatusId?: number | undefined;
    cErrorStatusId?: number | undefined;
    tErrorStatusId?: number | undefined;
    appraisalStatusId?: number | undefined;
    coreScore?: number | undefined;
    isVitals?: boolean | undefined;
    isCore?: boolean | undefined;
    webId?: string | undefined;
    ordinal?: number | undefined;
    dataLocked!: boolean;
    migrated!: boolean;
    assessmentPurposeId?: number | undefined;
    datasetId!: number;
    mobile?: boolean | undefined;
    force?: boolean | undefined;
    isDirty?: boolean | undefined;
    consent!: boolean;
    neurapulseState?: NeurapulseTestCompletionStatusType | undefined;
    neurapulseCompleted?: Date | undefined;
    neurapulseNonce?: string | undefined;
    neurapulseRecommendation?: NeurapulseRecommendationType | undefined;
    customFieldValues?: CustomFieldValue[] | undefined;

    constructor(data?: IAssessment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originalId = _data["originalId"];
            this.clientId = _data["clientId"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.dateCompleted = _data["dateCompleted"] ? new Date(_data["dateCompleted"].toString()) : <any>undefined;
            this.coreTestResultId = _data["coreTestResultId"];
            this.coreTest = _data["coreTest"] ? Core.fromJS(_data["coreTest"]) : <any>undefined;
            this.careTestResultId = _data["careTestResultId"];
            this.careTest = _data["careTest"] ? VitalsM.fromJS(_data["careTest"]) : <any>undefined;
            this.tripInspection = _data["tripInspection"] ? TripInspection.fromJS(_data["tripInspection"]) : <any>undefined;
            this.vitalsTestResultId = _data["vitalsTestResultId"];
            this.vitalsScore = _data["vitalsScore"];
            this.excelerateScore = _data["excelerateScore"];
            this.cognitiveErrorsTotal = _data["cognitiveErrorsTotal"];
            this.vitalsPremiumBenefit = _data["vitalsPremiumBenefit"];
            this.trainableErrorsTotal = _data["trainableErrorsTotal"];
            this.skillsAppraisalTotal = _data["skillsAppraisalTotal"];
            this.hasHazardousErrors = _data["hasHazardousErrors"];
            this.coreAborted = _data["coreAborted"];
            this.vitalsStatusId = _data["vitalsStatusId"];
            this.cErrorStatusId = _data["cErrorStatusId"];
            this.tErrorStatusId = _data["tErrorStatusId"];
            this.appraisalStatusId = _data["appraisalStatusId"];
            this.coreScore = _data["coreScore"];
            this.isVitals = _data["isVitals"];
            this.isCore = _data["isCore"];
            this.webId = _data["webId"];
            this.ordinal = _data["ordinal"];
            this.dataLocked = _data["dataLocked"];
            this.migrated = _data["migrated"];
            this.assessmentPurposeId = _data["assessmentPurposeId"];
            this.datasetId = _data["datasetId"];
            this.mobile = _data["mobile"];
            this.force = _data["force"];
            this.isDirty = _data["isDirty"];
            this.consent = _data["consent"];
            this.neurapulseState = _data["neurapulseState"];
            this.neurapulseCompleted = _data["neurapulseCompleted"] ? new Date(_data["neurapulseCompleted"].toString()) : <any>undefined;
            this.neurapulseNonce = _data["neurapulseNonce"];
            this.neurapulseRecommendation = _data["neurapulseRecommendation"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Assessment {
        data = typeof data === 'object' ? data : {};
        let result = new Assessment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalId"] = this.originalId;
        data["clientId"] = this.clientId;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["dateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : <any>undefined;
        data["coreTestResultId"] = this.coreTestResultId;
        data["coreTest"] = this.coreTest ? this.coreTest.toJSON() : <any>undefined;
        data["careTestResultId"] = this.careTestResultId;
        data["careTest"] = this.careTest ? this.careTest.toJSON() : <any>undefined;
        data["tripInspection"] = this.tripInspection ? this.tripInspection.toJSON() : <any>undefined;
        data["vitalsTestResultId"] = this.vitalsTestResultId;
        data["vitalsScore"] = this.vitalsScore;
        data["excelerateScore"] = this.excelerateScore;
        data["cognitiveErrorsTotal"] = this.cognitiveErrorsTotal;
        data["vitalsPremiumBenefit"] = this.vitalsPremiumBenefit;
        data["trainableErrorsTotal"] = this.trainableErrorsTotal;
        data["skillsAppraisalTotal"] = this.skillsAppraisalTotal;
        data["hasHazardousErrors"] = this.hasHazardousErrors;
        data["coreAborted"] = this.coreAborted;
        data["vitalsStatusId"] = this.vitalsStatusId;
        data["cErrorStatusId"] = this.cErrorStatusId;
        data["tErrorStatusId"] = this.tErrorStatusId;
        data["appraisalStatusId"] = this.appraisalStatusId;
        data["coreScore"] = this.coreScore;
        data["isVitals"] = this.isVitals;
        data["isCore"] = this.isCore;
        data["webId"] = this.webId;
        data["ordinal"] = this.ordinal;
        data["dataLocked"] = this.dataLocked;
        data["migrated"] = this.migrated;
        data["assessmentPurposeId"] = this.assessmentPurposeId;
        data["datasetId"] = this.datasetId;
        data["mobile"] = this.mobile;
        data["force"] = this.force;
        data["isDirty"] = this.isDirty;
        data["consent"] = this.consent;
        data["neurapulseState"] = this.neurapulseState;
        data["neurapulseCompleted"] = this.neurapulseCompleted ? this.neurapulseCompleted.toISOString() : <any>undefined;
        data["neurapulseNonce"] = this.neurapulseNonce;
        data["neurapulseRecommendation"] = this.neurapulseRecommendation;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssessment {
    id: number;
    originalId: number;
    clientId: number;
    dateCreated?: Date | undefined;
    dateModified?: Date | undefined;
    dateCompleted?: Date | undefined;
    coreTestResultId?: number | undefined;
    coreTest?: Core | undefined;
    careTestResultId?: number | undefined;
    careTest?: VitalsM | undefined;
    tripInspection?: TripInspection | undefined;
    vitalsTestResultId?: number | undefined;
    vitalsScore?: number | undefined;
    excelerateScore?: number | undefined;
    cognitiveErrorsTotal?: number | undefined;
    vitalsPremiumBenefit?: number | undefined;
    trainableErrorsTotal?: number | undefined;
    skillsAppraisalTotal?: number | undefined;
    hasHazardousErrors?: boolean | undefined;
    coreAborted?: boolean | undefined;
    vitalsStatusId?: number | undefined;
    cErrorStatusId?: number | undefined;
    tErrorStatusId?: number | undefined;
    appraisalStatusId?: number | undefined;
    coreScore?: number | undefined;
    isVitals?: boolean | undefined;
    isCore?: boolean | undefined;
    webId?: string | undefined;
    ordinal?: number | undefined;
    dataLocked: boolean;
    migrated: boolean;
    assessmentPurposeId?: number | undefined;
    datasetId: number;
    mobile?: boolean | undefined;
    force?: boolean | undefined;
    isDirty?: boolean | undefined;
    consent: boolean;
    neurapulseState?: NeurapulseTestCompletionStatusType | undefined;
    neurapulseCompleted?: Date | undefined;
    neurapulseNonce?: string | undefined;
    neurapulseRecommendation?: NeurapulseRecommendationType | undefined;
    customFieldValues?: CustomFieldValue[] | undefined;
}

export class NewCore implements INewCore {
    dateAdministered!: Date;
    dateCompleted?: Date | undefined;
    dateStarted?: Date | undefined;
    dateModified?: Date | undefined;
    locationId?: number | undefined;
    courseId?: number | undefined;
    clientId!: number;
    evaluatorId?: number | undefined;
    cooperativeId?: number | undefined;
    hearingImpairmentId?: number | undefined;
    visualImpairmentId?: number | undefined;
    physicalImpairmentId?: number | undefined;
    anxietyLevelId?: number | undefined;
    difficultyLevelId?: number | undefined;
    weatherRoadConditionsId?: number | undefined;
    vehicleTypeId?: number | undefined;
    vehicleSubTypeId?: number | undefined;
    cutPointId?: number | undefined;
    judgementId?: number | undefined;
    visualSkillsId?: number | undefined;
    vehicleControlId?: number | undefined;
    attentivenessId?: number | undefined;
    adherenceToRulesId?: number | undefined;
    overallPerformanceId?: number | undefined;
    testCreatorId?: number | undefined;
    lastEditedById?: number | undefined;
    coreGeneralSubmitted!: boolean;
    comments?: string | undefined;
    complete!: boolean;
    unassignedErrorsCount?: number | undefined;
    deviceDetails?: string | undefined;
    monthsCommercialDrivingExp?: number | undefined;
    coreErrorEntryCompleted!: boolean;
    dateCoreEntryCompleted?: Date | undefined;
    mobile?: boolean | undefined;
    impiricaMobileVersion?: string | undefined;
    customFieldValues?: CustomFieldValue[] | undefined;
    coreErrorEntryListItems?: CoreErrorEntryListItems[] | undefined;
    coreTestRoutes?: CoreTestRoute[] | undefined;

    constructor(data?: INewCore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateAdministered = _data["dateAdministered"] ? new Date(_data["dateAdministered"].toString()) : <any>undefined;
            this.dateCompleted = _data["dateCompleted"] ? new Date(_data["dateCompleted"].toString()) : <any>undefined;
            this.dateStarted = _data["dateStarted"] ? new Date(_data["dateStarted"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.locationId = _data["locationId"];
            this.courseId = _data["courseId"];
            this.clientId = _data["clientId"];
            this.evaluatorId = _data["evaluatorId"];
            this.cooperativeId = _data["cooperativeId"];
            this.hearingImpairmentId = _data["hearingImpairmentId"];
            this.visualImpairmentId = _data["visualImpairmentId"];
            this.physicalImpairmentId = _data["physicalImpairmentId"];
            this.anxietyLevelId = _data["anxietyLevelId"];
            this.difficultyLevelId = _data["difficultyLevelId"];
            this.weatherRoadConditionsId = _data["weatherRoadConditionsId"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleSubTypeId = _data["vehicleSubTypeId"];
            this.cutPointId = _data["cutPointId"];
            this.judgementId = _data["judgementId"];
            this.visualSkillsId = _data["visualSkillsId"];
            this.vehicleControlId = _data["vehicleControlId"];
            this.attentivenessId = _data["attentivenessId"];
            this.adherenceToRulesId = _data["adherenceToRulesId"];
            this.overallPerformanceId = _data["overallPerformanceId"];
            this.testCreatorId = _data["testCreatorId"];
            this.lastEditedById = _data["lastEditedById"];
            this.coreGeneralSubmitted = _data["coreGeneralSubmitted"];
            this.comments = _data["comments"];
            this.complete = _data["complete"];
            this.unassignedErrorsCount = _data["unassignedErrorsCount"];
            this.deviceDetails = _data["deviceDetails"];
            this.monthsCommercialDrivingExp = _data["monthsCommercialDrivingExp"];
            this.coreErrorEntryCompleted = _data["coreErrorEntryCompleted"];
            this.dateCoreEntryCompleted = _data["dateCoreEntryCompleted"] ? new Date(_data["dateCoreEntryCompleted"].toString()) : <any>undefined;
            this.mobile = _data["mobile"];
            this.impiricaMobileVersion = _data["impiricaMobileVersion"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValue.fromJS(item));
            }
            if (Array.isArray(_data["coreErrorEntryListItems"])) {
                this.coreErrorEntryListItems = [] as any;
                for (let item of _data["coreErrorEntryListItems"])
                    this.coreErrorEntryListItems!.push(CoreErrorEntryListItems.fromJS(item));
            }
            if (Array.isArray(_data["coreTestRoutes"])) {
                this.coreTestRoutes = [] as any;
                for (let item of _data["coreTestRoutes"])
                    this.coreTestRoutes!.push(CoreTestRoute.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewCore {
        data = typeof data === 'object' ? data : {};
        let result = new NewCore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateAdministered"] = this.dateAdministered ? this.dateAdministered.toISOString() : <any>undefined;
        data["dateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : <any>undefined;
        data["dateStarted"] = this.dateStarted ? this.dateStarted.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["locationId"] = this.locationId;
        data["courseId"] = this.courseId;
        data["clientId"] = this.clientId;
        data["evaluatorId"] = this.evaluatorId;
        data["cooperativeId"] = this.cooperativeId;
        data["hearingImpairmentId"] = this.hearingImpairmentId;
        data["visualImpairmentId"] = this.visualImpairmentId;
        data["physicalImpairmentId"] = this.physicalImpairmentId;
        data["anxietyLevelId"] = this.anxietyLevelId;
        data["difficultyLevelId"] = this.difficultyLevelId;
        data["weatherRoadConditionsId"] = this.weatherRoadConditionsId;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleSubTypeId"] = this.vehicleSubTypeId;
        data["cutPointId"] = this.cutPointId;
        data["judgementId"] = this.judgementId;
        data["visualSkillsId"] = this.visualSkillsId;
        data["vehicleControlId"] = this.vehicleControlId;
        data["attentivenessId"] = this.attentivenessId;
        data["adherenceToRulesId"] = this.adherenceToRulesId;
        data["overallPerformanceId"] = this.overallPerformanceId;
        data["testCreatorId"] = this.testCreatorId;
        data["lastEditedById"] = this.lastEditedById;
        data["coreGeneralSubmitted"] = this.coreGeneralSubmitted;
        data["comments"] = this.comments;
        data["complete"] = this.complete;
        data["unassignedErrorsCount"] = this.unassignedErrorsCount;
        data["deviceDetails"] = this.deviceDetails;
        data["monthsCommercialDrivingExp"] = this.monthsCommercialDrivingExp;
        data["coreErrorEntryCompleted"] = this.coreErrorEntryCompleted;
        data["dateCoreEntryCompleted"] = this.dateCoreEntryCompleted ? this.dateCoreEntryCompleted.toISOString() : <any>undefined;
        data["mobile"] = this.mobile;
        data["impiricaMobileVersion"] = this.impiricaMobileVersion;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        if (Array.isArray(this.coreErrorEntryListItems)) {
            data["coreErrorEntryListItems"] = [];
            for (let item of this.coreErrorEntryListItems)
                data["coreErrorEntryListItems"].push(item.toJSON());
        }
        if (Array.isArray(this.coreTestRoutes)) {
            data["coreTestRoutes"] = [];
            for (let item of this.coreTestRoutes)
                data["coreTestRoutes"].push(item.toJSON());
        }
        return data;
    }
}

export interface INewCore {
    dateAdministered: Date;
    dateCompleted?: Date | undefined;
    dateStarted?: Date | undefined;
    dateModified?: Date | undefined;
    locationId?: number | undefined;
    courseId?: number | undefined;
    clientId: number;
    evaluatorId?: number | undefined;
    cooperativeId?: number | undefined;
    hearingImpairmentId?: number | undefined;
    visualImpairmentId?: number | undefined;
    physicalImpairmentId?: number | undefined;
    anxietyLevelId?: number | undefined;
    difficultyLevelId?: number | undefined;
    weatherRoadConditionsId?: number | undefined;
    vehicleTypeId?: number | undefined;
    vehicleSubTypeId?: number | undefined;
    cutPointId?: number | undefined;
    judgementId?: number | undefined;
    visualSkillsId?: number | undefined;
    vehicleControlId?: number | undefined;
    attentivenessId?: number | undefined;
    adherenceToRulesId?: number | undefined;
    overallPerformanceId?: number | undefined;
    testCreatorId?: number | undefined;
    lastEditedById?: number | undefined;
    coreGeneralSubmitted: boolean;
    comments?: string | undefined;
    complete: boolean;
    unassignedErrorsCount?: number | undefined;
    deviceDetails?: string | undefined;
    monthsCommercialDrivingExp?: number | undefined;
    coreErrorEntryCompleted: boolean;
    dateCoreEntryCompleted?: Date | undefined;
    mobile?: boolean | undefined;
    impiricaMobileVersion?: string | undefined;
    customFieldValues?: CustomFieldValue[] | undefined;
    coreErrorEntryListItems?: CoreErrorEntryListItems[] | undefined;
    coreTestRoutes?: CoreTestRoute[] | undefined;
}

export class Core extends NewCore implements ICore {
    id!: number;
    originalId?: number | undefined;

    constructor(data?: ICore) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.originalId = _data["originalId"];
        }
    }

    static override fromJS(data: any): Core {
        data = typeof data === 'object' ? data : {};
        let result = new Core();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalId"] = this.originalId;
        super.toJSON(data);
        return data;
    }
}

export interface ICore extends INewCore {
    id: number;
    originalId?: number | undefined;
}

export class CustomFieldValue implements ICustomFieldValue {
    id!: number;
    clientId?: number | undefined;
    customFieldId!: number;
    coreTestResultId?: number | undefined;
    assessmentResultId?: number | undefined;
    vitalsTestResultId?: number | undefined;
    careTestResultId?: number | undefined;
    value?: string | undefined;

    constructor(data?: ICustomFieldValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.customFieldId = _data["customFieldId"];
            this.coreTestResultId = _data["coreTestResultId"];
            this.assessmentResultId = _data["assessmentResultId"];
            this.vitalsTestResultId = _data["vitalsTestResultId"];
            this.careTestResultId = _data["careTestResultId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomFieldValue {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFieldValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["customFieldId"] = this.customFieldId;
        data["coreTestResultId"] = this.coreTestResultId;
        data["assessmentResultId"] = this.assessmentResultId;
        data["vitalsTestResultId"] = this.vitalsTestResultId;
        data["careTestResultId"] = this.careTestResultId;
        data["value"] = this.value;
        return data;
    }
}

export interface ICustomFieldValue {
    id: number;
    clientId?: number | undefined;
    customFieldId: number;
    coreTestResultId?: number | undefined;
    assessmentResultId?: number | undefined;
    vitalsTestResultId?: number | undefined;
    careTestResultId?: number | undefined;
    value?: string | undefined;
}

export class CoreErrorEntryListItems implements ICoreErrorEntryListItems {
    id!: number;
    coreTestResultId!: number;
    fleetErrorId!: number;
    errorValue!: number;
    latitude?: number | undefined;
    longitude?: number | undefined;
    timestamp?: Date | undefined;
    accuracy?: number | undefined;
    altitude?: number | undefined;
    altitudeAccuracy?: number | undefined;
    heading?: number | undefined;
    speed?: number | undefined;
    additionalNotes?: string | undefined;
    skillCategoryDescription?: string | undefined;
    skillCategoryId!: number;

    constructor(data?: ICoreErrorEntryListItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.coreTestResultId = _data["coreTestResultId"];
            this.fleetErrorId = _data["fleetErrorId"];
            this.errorValue = _data["errorValue"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.accuracy = _data["accuracy"];
            this.altitude = _data["altitude"];
            this.altitudeAccuracy = _data["altitudeAccuracy"];
            this.heading = _data["heading"];
            this.speed = _data["speed"];
            this.additionalNotes = _data["additionalNotes"];
            this.skillCategoryDescription = _data["skillCategoryDescription"];
            this.skillCategoryId = _data["skillCategoryId"];
        }
    }

    static fromJS(data: any): CoreErrorEntryListItems {
        data = typeof data === 'object' ? data : {};
        let result = new CoreErrorEntryListItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coreTestResultId"] = this.coreTestResultId;
        data["fleetErrorId"] = this.fleetErrorId;
        data["errorValue"] = this.errorValue;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["accuracy"] = this.accuracy;
        data["altitude"] = this.altitude;
        data["altitudeAccuracy"] = this.altitudeAccuracy;
        data["heading"] = this.heading;
        data["speed"] = this.speed;
        data["additionalNotes"] = this.additionalNotes;
        data["skillCategoryDescription"] = this.skillCategoryDescription;
        data["skillCategoryId"] = this.skillCategoryId;
        return data;
    }
}

export interface ICoreErrorEntryListItems {
    id: number;
    coreTestResultId: number;
    fleetErrorId: number;
    errorValue: number;
    latitude?: number | undefined;
    longitude?: number | undefined;
    timestamp?: Date | undefined;
    accuracy?: number | undefined;
    altitude?: number | undefined;
    altitudeAccuracy?: number | undefined;
    heading?: number | undefined;
    speed?: number | undefined;
    additionalNotes?: string | undefined;
    skillCategoryDescription?: string | undefined;
    skillCategoryId: number;
}

export class CoreTestRoute implements ICoreTestRoute {
    id!: number;
    coreTestResultId!: number;
    latitude!: number;
    longitude!: number;
    timestamp?: Date | undefined;
    accuracy?: number | undefined;
    altitude?: number | undefined;
    altitudeAccuracy?: number | undefined;
    heading?: number | undefined;
    speed?: number | undefined;

    constructor(data?: ICoreTestRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.coreTestResultId = _data["coreTestResultId"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.accuracy = _data["accuracy"];
            this.altitude = _data["altitude"];
            this.altitudeAccuracy = _data["altitudeAccuracy"];
            this.heading = _data["heading"];
            this.speed = _data["speed"];
        }
    }

    static fromJS(data: any): CoreTestRoute {
        data = typeof data === 'object' ? data : {};
        let result = new CoreTestRoute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coreTestResultId"] = this.coreTestResultId;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["accuracy"] = this.accuracy;
        data["altitude"] = this.altitude;
        data["altitudeAccuracy"] = this.altitudeAccuracy;
        data["heading"] = this.heading;
        data["speed"] = this.speed;
        return data;
    }
}

export interface ICoreTestRoute {
    id: number;
    coreTestResultId: number;
    latitude: number;
    longitude: number;
    timestamp?: Date | undefined;
    accuracy?: number | undefined;
    altitude?: number | undefined;
    altitudeAccuracy?: number | undefined;
    heading?: number | undefined;
    speed?: number | undefined;
}

export class VitalsM implements IVitalsM {
    id!: number;
    originalId?: number | undefined;
    telemetry?: string | undefined;
    dateStarted!: Date;
    dateCompleted?: Date | undefined;
    dateModified?: Date | undefined;
    handedness?: HandednessType | undefined;
    colourBlind?: boolean | undefined;
    configurationVersionId!: number;
    complete!: boolean;
    evaluatorId!: number;
    clientId!: number;
    configurationUsed?: string | undefined;
    impiricaMobileVersion?: string | undefined;
    impairedProbability?: number | undefined;
    notImpairedProbability?: number | undefined;
    dichotomousCutpoint?: number | undefined;
    trichotomousLowCutpoint?: number | undefined;
    trichotomousHighCutpoint?: number | undefined;
    dichotomousDecision?: CareScoringDecisionType | undefined;
    trichotomousDecision?: CareScoringDecisionType | undefined;
    customFieldValues?: CustomFieldValue[] | undefined;
    ccmtaAttention?: CCMTALabelValueType | undefined;
    ccmtaExecutiveFunction?: CCMTALabelValueType | undefined;
    ccmtaMemory?: CCMTALabelValueType | undefined;
    ccmtaReactions?: CCMTALabelValueType | undefined;
    ccmtaTracking?: CCMTALabelValueType | undefined;
    ccmtaVisuospatial?: CCMTALabelValueType | undefined;
    comments?: string | undefined;
    languageCode?: string | undefined;
    anxietyLevelId?: number | undefined;
    cooperativeId?: number | undefined;
    hearingImpairmentId?: number | undefined;
    physicalImpairmentId?: number | undefined;
    visualImpairmentId?: number | undefined;
    deviceDetails?: string | undefined;
    reactionTimePercentile?: number | undefined;
    judgementPercentile?: number | undefined;
    memoryPercentile?: number | undefined;
    controlPercentile?: number | undefined;
    aborted?: boolean | undefined;
    subMetrics?: CareTestResultSubMetric[] | undefined;

    constructor(data?: IVitalsM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originalId = _data["originalId"];
            this.telemetry = _data["telemetry"];
            this.dateStarted = _data["dateStarted"] ? new Date(_data["dateStarted"].toString()) : <any>undefined;
            this.dateCompleted = _data["dateCompleted"] ? new Date(_data["dateCompleted"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.handedness = _data["handedness"];
            this.colourBlind = _data["colourBlind"];
            this.configurationVersionId = _data["configurationVersionId"];
            this.complete = _data["complete"];
            this.evaluatorId = _data["evaluatorId"];
            this.clientId = _data["clientId"];
            this.configurationUsed = _data["configurationUsed"];
            this.impiricaMobileVersion = _data["impiricaMobileVersion"];
            this.impairedProbability = _data["impairedProbability"];
            this.notImpairedProbability = _data["notImpairedProbability"];
            this.dichotomousCutpoint = _data["dichotomousCutpoint"];
            this.trichotomousLowCutpoint = _data["trichotomousLowCutpoint"];
            this.trichotomousHighCutpoint = _data["trichotomousHighCutpoint"];
            this.dichotomousDecision = _data["dichotomousDecision"];
            this.trichotomousDecision = _data["trichotomousDecision"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValue.fromJS(item));
            }
            this.ccmtaAttention = _data["ccmtaAttention"];
            this.ccmtaExecutiveFunction = _data["ccmtaExecutiveFunction"];
            this.ccmtaMemory = _data["ccmtaMemory"];
            this.ccmtaReactions = _data["ccmtaReactions"];
            this.ccmtaTracking = _data["ccmtaTracking"];
            this.ccmtaVisuospatial = _data["ccmtaVisuospatial"];
            this.comments = _data["comments"];
            this.languageCode = _data["languageCode"];
            this.anxietyLevelId = _data["anxietyLevelId"];
            this.cooperativeId = _data["cooperativeId"];
            this.hearingImpairmentId = _data["hearingImpairmentId"];
            this.physicalImpairmentId = _data["physicalImpairmentId"];
            this.visualImpairmentId = _data["visualImpairmentId"];
            this.deviceDetails = _data["deviceDetails"];
            this.reactionTimePercentile = _data["reactionTimePercentile"];
            this.judgementPercentile = _data["judgementPercentile"];
            this.memoryPercentile = _data["memoryPercentile"];
            this.controlPercentile = _data["controlPercentile"];
            this.aborted = _data["aborted"];
            if (Array.isArray(_data["subMetrics"])) {
                this.subMetrics = [] as any;
                for (let item of _data["subMetrics"])
                    this.subMetrics!.push(CareTestResultSubMetric.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VitalsM {
        data = typeof data === 'object' ? data : {};
        let result = new VitalsM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalId"] = this.originalId;
        data["telemetry"] = this.telemetry;
        data["dateStarted"] = this.dateStarted ? this.dateStarted.toISOString() : <any>undefined;
        data["dateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["handedness"] = this.handedness;
        data["colourBlind"] = this.colourBlind;
        data["configurationVersionId"] = this.configurationVersionId;
        data["complete"] = this.complete;
        data["evaluatorId"] = this.evaluatorId;
        data["clientId"] = this.clientId;
        data["configurationUsed"] = this.configurationUsed;
        data["impiricaMobileVersion"] = this.impiricaMobileVersion;
        data["impairedProbability"] = this.impairedProbability;
        data["notImpairedProbability"] = this.notImpairedProbability;
        data["dichotomousCutpoint"] = this.dichotomousCutpoint;
        data["trichotomousLowCutpoint"] = this.trichotomousLowCutpoint;
        data["trichotomousHighCutpoint"] = this.trichotomousHighCutpoint;
        data["dichotomousDecision"] = this.dichotomousDecision;
        data["trichotomousDecision"] = this.trichotomousDecision;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        data["ccmtaAttention"] = this.ccmtaAttention;
        data["ccmtaExecutiveFunction"] = this.ccmtaExecutiveFunction;
        data["ccmtaMemory"] = this.ccmtaMemory;
        data["ccmtaReactions"] = this.ccmtaReactions;
        data["ccmtaTracking"] = this.ccmtaTracking;
        data["ccmtaVisuospatial"] = this.ccmtaVisuospatial;
        data["comments"] = this.comments;
        data["languageCode"] = this.languageCode;
        data["anxietyLevelId"] = this.anxietyLevelId;
        data["cooperativeId"] = this.cooperativeId;
        data["hearingImpairmentId"] = this.hearingImpairmentId;
        data["physicalImpairmentId"] = this.physicalImpairmentId;
        data["visualImpairmentId"] = this.visualImpairmentId;
        data["deviceDetails"] = this.deviceDetails;
        data["reactionTimePercentile"] = this.reactionTimePercentile;
        data["judgementPercentile"] = this.judgementPercentile;
        data["memoryPercentile"] = this.memoryPercentile;
        data["controlPercentile"] = this.controlPercentile;
        data["aborted"] = this.aborted;
        if (Array.isArray(this.subMetrics)) {
            data["subMetrics"] = [];
            for (let item of this.subMetrics)
                data["subMetrics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVitalsM {
    id: number;
    originalId?: number | undefined;
    telemetry?: string | undefined;
    dateStarted: Date;
    dateCompleted?: Date | undefined;
    dateModified?: Date | undefined;
    handedness?: HandednessType | undefined;
    colourBlind?: boolean | undefined;
    configurationVersionId: number;
    complete: boolean;
    evaluatorId: number;
    clientId: number;
    configurationUsed?: string | undefined;
    impiricaMobileVersion?: string | undefined;
    impairedProbability?: number | undefined;
    notImpairedProbability?: number | undefined;
    dichotomousCutpoint?: number | undefined;
    trichotomousLowCutpoint?: number | undefined;
    trichotomousHighCutpoint?: number | undefined;
    dichotomousDecision?: CareScoringDecisionType | undefined;
    trichotomousDecision?: CareScoringDecisionType | undefined;
    customFieldValues?: CustomFieldValue[] | undefined;
    ccmtaAttention?: CCMTALabelValueType | undefined;
    ccmtaExecutiveFunction?: CCMTALabelValueType | undefined;
    ccmtaMemory?: CCMTALabelValueType | undefined;
    ccmtaReactions?: CCMTALabelValueType | undefined;
    ccmtaTracking?: CCMTALabelValueType | undefined;
    ccmtaVisuospatial?: CCMTALabelValueType | undefined;
    comments?: string | undefined;
    languageCode?: string | undefined;
    anxietyLevelId?: number | undefined;
    cooperativeId?: number | undefined;
    hearingImpairmentId?: number | undefined;
    physicalImpairmentId?: number | undefined;
    visualImpairmentId?: number | undefined;
    deviceDetails?: string | undefined;
    reactionTimePercentile?: number | undefined;
    judgementPercentile?: number | undefined;
    memoryPercentile?: number | undefined;
    controlPercentile?: number | undefined;
    aborted?: boolean | undefined;
    subMetrics?: CareTestResultSubMetric[] | undefined;
}

export enum HandednessType {
    Unknown = 0,
    Right = 1,
    Left = 2,
}

export enum CareScoringDecisionType {
    Pass = 0,
    Fail = 1,
    RangeOfInquiry = 2,
    Aborted = 3,
}

export enum CCMTALabelValueType {
    Average = 0,
    BelowAverage = 1,
    AboveAverage = 2,
}

export class CareTestResultSubMetric implements ICareTestResultSubMetric {
    careTestResultId!: number;
    taskType!: string;
    key!: string;
    value?: string | undefined;

    constructor(data?: ICareTestResultSubMetric) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careTestResultId = _data["careTestResultId"];
            this.taskType = _data["taskType"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CareTestResultSubMetric {
        data = typeof data === 'object' ? data : {};
        let result = new CareTestResultSubMetric();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careTestResultId"] = this.careTestResultId;
        data["taskType"] = this.taskType;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ICareTestResultSubMetric {
    careTestResultId: number;
    taskType: string;
    key: string;
    value?: string | undefined;
}

export class TripInspection implements ITripInspection {
    id!: number;
    assessmentResultId!: number;
    vehicleSubTypeId!: number;
    createdBy!: number;
    createdOn!: Date;
    modifiedBy?: number | undefined;
    modifiedOn?: Date | undefined;
    deviceDetails?: string | undefined;
    tripTaskComments?: TripTaskComment[] | undefined;
    tripObservations?: TripObservation[] | undefined;

    constructor(data?: ITripInspection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assessmentResultId = _data["assessmentResultId"];
            this.vehicleSubTypeId = _data["vehicleSubTypeId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deviceDetails = _data["deviceDetails"];
            if (Array.isArray(_data["tripTaskComments"])) {
                this.tripTaskComments = [] as any;
                for (let item of _data["tripTaskComments"])
                    this.tripTaskComments!.push(TripTaskComment.fromJS(item));
            }
            if (Array.isArray(_data["tripObservations"])) {
                this.tripObservations = [] as any;
                for (let item of _data["tripObservations"])
                    this.tripObservations!.push(TripObservation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TripInspection {
        data = typeof data === 'object' ? data : {};
        let result = new TripInspection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assessmentResultId"] = this.assessmentResultId;
        data["vehicleSubTypeId"] = this.vehicleSubTypeId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deviceDetails"] = this.deviceDetails;
        if (Array.isArray(this.tripTaskComments)) {
            data["tripTaskComments"] = [];
            for (let item of this.tripTaskComments)
                data["tripTaskComments"].push(item.toJSON());
        }
        if (Array.isArray(this.tripObservations)) {
            data["tripObservations"] = [];
            for (let item of this.tripObservations)
                data["tripObservations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITripInspection {
    id: number;
    assessmentResultId: number;
    vehicleSubTypeId: number;
    createdBy: number;
    createdOn: Date;
    modifiedBy?: number | undefined;
    modifiedOn?: Date | undefined;
    deviceDetails?: string | undefined;
    tripTaskComments?: TripTaskComment[] | undefined;
    tripObservations?: TripObservation[] | undefined;
}

export class TripTaskComment implements ITripTaskComment {
    id!: number;
    tripInspectionId!: number;
    tripTaskId!: number;
    observed!: boolean;
    comment?: string | undefined;
    createdBy!: number;
    createdOn!: Date;
    modifiedBy?: number | undefined;
    modifiedOn?: Date | undefined;

    constructor(data?: ITripTaskComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tripInspectionId = _data["tripInspectionId"];
            this.tripTaskId = _data["tripTaskId"];
            this.observed = _data["observed"];
            this.comment = _data["comment"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TripTaskComment {
        data = typeof data === 'object' ? data : {};
        let result = new TripTaskComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tripInspectionId"] = this.tripInspectionId;
        data["tripTaskId"] = this.tripTaskId;
        data["observed"] = this.observed;
        data["comment"] = this.comment;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITripTaskComment {
    id: number;
    tripInspectionId: number;
    tripTaskId: number;
    observed: boolean;
    comment?: string | undefined;
    createdBy: number;
    createdOn: Date;
    modifiedBy?: number | undefined;
    modifiedOn?: Date | undefined;
}

export class TripObservation implements ITripObservation {
    id!: number;
    tripInspectionId!: number;
    tripObservationTypeId!: number;
    score?: number | undefined;
    notApplicable!: boolean;
    comment?: string | undefined;
    createdBy!: number;
    createdOn!: Date;
    modifiedBy?: number | undefined;
    modifiedOn?: Date | undefined;

    constructor(data?: ITripObservation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tripInspectionId = _data["tripInspectionId"];
            this.tripObservationTypeId = _data["tripObservationTypeId"];
            this.score = _data["score"];
            this.notApplicable = _data["notApplicable"];
            this.comment = _data["comment"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TripObservation {
        data = typeof data === 'object' ? data : {};
        let result = new TripObservation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tripInspectionId"] = this.tripInspectionId;
        data["tripObservationTypeId"] = this.tripObservationTypeId;
        data["score"] = this.score;
        data["notApplicable"] = this.notApplicable;
        data["comment"] = this.comment;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITripObservation {
    id: number;
    tripInspectionId: number;
    tripObservationTypeId: number;
    score?: number | undefined;
    notApplicable: boolean;
    comment?: string | undefined;
    createdBy: number;
    createdOn: Date;
    modifiedBy?: number | undefined;
    modifiedOn?: Date | undefined;
}

export enum NeurapulseTestCompletionStatusType {
    UnknownStatus = 0,
    Started = 1,
    Completed = 2,
    CouldNotCompleteConnectionIssues = 3,
    CouldNotCompleteNpServerIssues = 4,
    CouldNotCompleteTimedOut = 5,
    CouldNotCompleteUnsupportedDevice = 6,
    Confirming = 7,
    HighRisk = 8,
    InProgress = 9,
    NotStarted = 10,
    Incomplete = 11,
}

export enum NeurapulseRecommendationType {
    Completed = 0,
    Incomplete = 1,
    HighRisk = 2,
}

export class ClientXrefDatasets implements IClientXrefDatasets {
    clientId!: number;
    datasetId!: number;

    constructor(data?: IClientXrefDatasets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.datasetId = _data["datasetId"];
        }
    }

    static fromJS(data: any): ClientXrefDatasets {
        data = typeof data === 'object' ? data : {};
        let result = new ClientXrefDatasets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["datasetId"] = this.datasetId;
        return data;
    }
}

export interface IClientXrefDatasets {
    clientId: number;
    datasetId: number;
}

export class AssessmentMatches implements IAssessmentMatches {
    originalId!: number;
    clientId!: number;
    matchingAssessments?: Assessment[] | undefined;

    constructor(data?: IAssessmentMatches) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalId = _data["originalId"];
            this.clientId = _data["clientId"];
            if (Array.isArray(_data["matchingAssessments"])) {
                this.matchingAssessments = [] as any;
                for (let item of _data["matchingAssessments"])
                    this.matchingAssessments!.push(Assessment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentMatches {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentMatches();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalId"] = this.originalId;
        data["clientId"] = this.clientId;
        if (Array.isArray(this.matchingAssessments)) {
            data["matchingAssessments"] = [];
            for (let item of this.matchingAssessments)
                data["matchingAssessments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssessmentMatches {
    originalId: number;
    clientId: number;
    matchingAssessments?: Assessment[] | undefined;
}

export class AssessmentMatchCriteria implements IAssessmentMatchCriteria {
    datasetId!: number;
    clientId!: number;
    originalId!: number;
    originalHasVITALSM!: boolean;
    originalHasCORE!: boolean;
    originalLastModified!: Date;

    constructor(data?: IAssessmentMatchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datasetId = _data["datasetId"];
            this.clientId = _data["clientId"];
            this.originalId = _data["originalId"];
            this.originalHasVITALSM = _data["originalHasVITALSM"];
            this.originalHasCORE = _data["originalHasCORE"];
            this.originalLastModified = _data["originalLastModified"] ? new Date(_data["originalLastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AssessmentMatchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentMatchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasetId"] = this.datasetId;
        data["clientId"] = this.clientId;
        data["originalId"] = this.originalId;
        data["originalHasVITALSM"] = this.originalHasVITALSM;
        data["originalHasCORE"] = this.originalHasCORE;
        data["originalLastModified"] = this.originalLastModified ? this.originalLastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAssessmentMatchCriteria {
    datasetId: number;
    clientId: number;
    originalId: number;
    originalHasVITALSM: boolean;
    originalHasCORE: boolean;
    originalLastModified: Date;
}

export class LastModified implements ILastModified {
    dateModified!: Date;
    modifiedBy?: string | undefined;

    constructor(data?: ILastModified) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): LastModified {
        data = typeof data === 'object' ? data : {};
        let result = new LastModified();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface ILastModified {
    dateModified: Date;
    modifiedBy?: string | undefined;
}

export class CareConfiguration implements ICareConfiguration {
    id!: number;
    name?: string | undefined;
    description?: string | undefined;
    adHoc!: boolean;
    isActive!: boolean;
    createdDate!: Date;
    lastModifiedDate?: Date | undefined;

    constructor(data?: ICareConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.adHoc = _data["adHoc"];
            this.isActive = _data["isActive"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CareConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new CareConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["adHoc"] = this.adHoc;
        data["isActive"] = this.isActive;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICareConfiguration {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    adHoc: boolean;
    isActive: boolean;
    createdDate: Date;
    lastModifiedDate?: Date | undefined;
}

export class CareConfigurationVersion implements ICareConfigurationVersion {
    id!: number;
    careConfigurationId!: number;
    version?: string | undefined;
    configJSON?: string | undefined;
    scoringVersion!: number;
    createdDate!: Date;
    lastModifiedDate?: Date | undefined;

    constructor(data?: ICareConfigurationVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.careConfigurationId = _data["careConfigurationId"];
            this.version = _data["version"];
            this.configJSON = _data["configJSON"];
            this.scoringVersion = _data["scoringVersion"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CareConfigurationVersion {
        data = typeof data === 'object' ? data : {};
        let result = new CareConfigurationVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["careConfigurationId"] = this.careConfigurationId;
        data["version"] = this.version;
        data["configJSON"] = this.configJSON;
        data["scoringVersion"] = this.scoringVersion;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICareConfigurationVersion {
    id: number;
    careConfigurationId: number;
    version?: string | undefined;
    configJSON?: string | undefined;
    scoringVersion: number;
    createdDate: Date;
    lastModifiedDate?: Date | undefined;
}

export class VitalsSummary implements IVitalsSummary {
    id!: number;
    anxietyLevelId?: number | undefined;
    cooperativeId?: number | undefined;
    hearingImpairmentId?: number | undefined;
    physicalImpairmentId?: number | undefined;
    visualImpairmentId?: number | undefined;
    comments?: string | undefined;

    constructor(data?: IVitalsSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.anxietyLevelId = _data["anxietyLevelId"];
            this.cooperativeId = _data["cooperativeId"];
            this.hearingImpairmentId = _data["hearingImpairmentId"];
            this.physicalImpairmentId = _data["physicalImpairmentId"];
            this.visualImpairmentId = _data["visualImpairmentId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): VitalsSummary {
        data = typeof data === 'object' ? data : {};
        let result = new VitalsSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["anxietyLevelId"] = this.anxietyLevelId;
        data["cooperativeId"] = this.cooperativeId;
        data["hearingImpairmentId"] = this.hearingImpairmentId;
        data["physicalImpairmentId"] = this.physicalImpairmentId;
        data["visualImpairmentId"] = this.visualImpairmentId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IVitalsSummary {
    id: number;
    anxietyLevelId?: number | undefined;
    cooperativeId?: number | undefined;
    hearingImpairmentId?: number | undefined;
    physicalImpairmentId?: number | undefined;
    visualImpairmentId?: number | undefined;
    comments?: string | undefined;
}

export class ClientMatch implements IClientMatch {
    datasetId!: number;
    originalClientId!: number;
    matchingClients?: Client[] | undefined;

    constructor(data?: IClientMatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datasetId = _data["datasetId"];
            this.originalClientId = _data["originalClientId"];
            if (Array.isArray(_data["matchingClients"])) {
                this.matchingClients = [] as any;
                for (let item of _data["matchingClients"])
                    this.matchingClients!.push(Client.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientMatch {
        data = typeof data === 'object' ? data : {};
        let result = new ClientMatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasetId"] = this.datasetId;
        data["originalClientId"] = this.originalClientId;
        if (Array.isArray(this.matchingClients)) {
            data["matchingClients"] = [];
            for (let item of this.matchingClients)
                data["matchingClients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClientMatch {
    datasetId: number;
    originalClientId: number;
    matchingClients?: Client[] | undefined;
}

export class ClientsMatchCriteria implements IClientsMatchCriteria {
    datasetId!: number;
    clients?: Client[] | undefined;

    constructor(data?: IClientsMatchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datasetId = _data["datasetId"];
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(Client.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientsMatchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new ClientsMatchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasetId"] = this.datasetId;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClientsMatchCriteria {
    datasetId: number;
    clients?: Client[] | undefined;
}

export class TrainingQuizResultRequest implements ITrainingQuizResultRequest {
    passed!: boolean;
    results?: Results | undefined;

    constructor(data?: ITrainingQuizResultRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passed = _data["passed"];
            this.results = _data["results"];
        }
    }

    static fromJS(data: any): TrainingQuizResultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingQuizResultRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passed"] = this.passed;
        data["results"] = this.results;
        return data;
    }
}

export interface ITrainingQuizResultRequest {
    passed: boolean;
    results?: Results | undefined;
}

export class SyncVideoRequest implements ISyncVideoRequest {
    source!: TrainingSyncSource;

    constructor(data?: ISyncVideoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): SyncVideoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SyncVideoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        return data;
    }
}

export interface ISyncVideoRequest {
    source: TrainingSyncSource;
}

export enum TrainingSyncSource {
    PlayerEvent = 1,
    ModalClose = 2,
    AdminResync = 3,
    Backfill = 4,
    StaleRefresh = 5,
    QuizEvidence = 6,
}

export class CustomField implements ICustomField {
    id!: number;
    organizationId!: number;
    name?: string | undefined;
    placeholderText?: string | undefined;
    controlTypeId!: number;
    controlTypeCode?: string | undefined;
    customFieldType!: number;
    showInReport!: boolean;
    showInListView!: boolean;
    includeInExport!: boolean;
    required!: boolean;
    phi!: boolean;
    isActive!: boolean;
    clientId?: number | undefined;
    options?: string | undefined;
    viewOrder!: number;

    constructor(data?: ICustomField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.placeholderText = _data["placeholderText"];
            this.controlTypeId = _data["controlTypeId"];
            this.controlTypeCode = _data["controlTypeCode"];
            this.customFieldType = _data["customFieldType"];
            this.showInReport = _data["showInReport"];
            this.showInListView = _data["showInListView"];
            this.includeInExport = _data["includeInExport"];
            this.required = _data["required"];
            this.phi = _data["phi"];
            this.isActive = _data["isActive"];
            this.clientId = _data["clientId"];
            this.options = _data["options"];
            this.viewOrder = _data["viewOrder"];
        }
    }

    static fromJS(data: any): CustomField {
        data = typeof data === 'object' ? data : {};
        let result = new CustomField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["placeholderText"] = this.placeholderText;
        data["controlTypeId"] = this.controlTypeId;
        data["controlTypeCode"] = this.controlTypeCode;
        data["customFieldType"] = this.customFieldType;
        data["showInReport"] = this.showInReport;
        data["showInListView"] = this.showInListView;
        data["includeInExport"] = this.includeInExport;
        data["required"] = this.required;
        data["phi"] = this.phi;
        data["isActive"] = this.isActive;
        data["clientId"] = this.clientId;
        data["options"] = this.options;
        data["viewOrder"] = this.viewOrder;
        return data;
    }
}

export interface ICustomField {
    id: number;
    organizationId: number;
    name?: string | undefined;
    placeholderText?: string | undefined;
    controlTypeId: number;
    controlTypeCode?: string | undefined;
    customFieldType: number;
    showInReport: boolean;
    showInListView: boolean;
    includeInExport: boolean;
    required: boolean;
    phi: boolean;
    isActive: boolean;
    clientId?: number | undefined;
    options?: string | undefined;
    viewOrder: number;
}

export class Dataset implements IDataset {
    id!: number;
    name?: string | undefined;
    permissions?: string[] | undefined;
    careConfigurationVersionId!: number;
    clientCount!: number;
    locations?: Location[] | undefined;
    vehicleTypes?: PickList[] | undefined;
    careConfigurationJSON?: string | undefined;
    product?: Product | undefined;
    training!: boolean;
    datasetPurposeTypeId!: number;
    datasetPurpose?: DatasetPurposeType | undefined;
    modifiedOn?: Date | undefined;
    showClientFirstName!: boolean;
    showClientLastName!: boolean;
    showClientParticipantId!: boolean;
    showClientBirthMonth!: boolean;
    showClientBirthDay!: boolean;
    showClientAddress!: boolean;
    maxioSubscriptionId!: number;
    neurapulseApiKey?: string | undefined;
    neurapulseProjectId?: string | undefined;
    organizationId!: number;
    modules?: Module[] | undefined;
    canCreateAssessment!: boolean;
    canEditCognitiveTest!: boolean;
    canViewCognitiveTest!: boolean;
    canEditOnRoadTest!: boolean;
    canViewOnRoadTest!: boolean;
    canViewAssessment!: boolean;
    canCreateClient!: boolean;
    canViewClients!: boolean;
    canViewDataset!: boolean;
    customFields?: CustomField[] | undefined;
    clientCustomFields?: CustomField[] | undefined;
    coreCustomFields?: CustomField[] | undefined;
    vitalsMCustomFields?: CustomField[] | undefined;
    assessmentCustomFields?: CustomField[] | undefined;

    constructor(data?: IDataset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.careConfigurationVersionId = _data["careConfigurationVersionId"];
            this.clientCount = _data["clientCount"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(Location.fromJS(item));
            }
            if (Array.isArray(_data["vehicleTypes"])) {
                this.vehicleTypes = [] as any;
                for (let item of _data["vehicleTypes"])
                    this.vehicleTypes!.push(PickList.fromJS(item));
            }
            this.careConfigurationJSON = _data["careConfigurationJSON"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.training = _data["training"];
            this.datasetPurposeTypeId = _data["datasetPurposeTypeId"];
            this.datasetPurpose = _data["datasetPurpose"] ? DatasetPurposeType.fromJS(_data["datasetPurpose"]) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.showClientFirstName = _data["showClientFirstName"];
            this.showClientLastName = _data["showClientLastName"];
            this.showClientParticipantId = _data["showClientParticipantId"];
            this.showClientBirthMonth = _data["showClientBirthMonth"];
            this.showClientBirthDay = _data["showClientBirthDay"];
            this.showClientAddress = _data["showClientAddress"];
            this.maxioSubscriptionId = _data["maxioSubscriptionId"];
            this.neurapulseApiKey = _data["neurapulseApiKey"];
            this.neurapulseProjectId = _data["neurapulseProjectId"];
            this.organizationId = _data["organizationId"];
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(Module.fromJS(item));
            }
            this.canCreateAssessment = _data["canCreateAssessment"];
            this.canEditCognitiveTest = _data["canEditCognitiveTest"];
            this.canViewCognitiveTest = _data["canViewCognitiveTest"];
            this.canEditOnRoadTest = _data["canEditOnRoadTest"];
            this.canViewOnRoadTest = _data["canViewOnRoadTest"];
            this.canViewAssessment = _data["canViewAssessment"];
            this.canCreateClient = _data["canCreateClient"];
            this.canViewClients = _data["canViewClients"];
            this.canViewDataset = _data["canViewDataset"];
            if (Array.isArray(_data["customFields"])) {
                this.customFields = [] as any;
                for (let item of _data["customFields"])
                    this.customFields!.push(CustomField.fromJS(item));
            }
            if (Array.isArray(_data["clientCustomFields"])) {
                this.clientCustomFields = [] as any;
                for (let item of _data["clientCustomFields"])
                    this.clientCustomFields!.push(CustomField.fromJS(item));
            }
            if (Array.isArray(_data["coreCustomFields"])) {
                this.coreCustomFields = [] as any;
                for (let item of _data["coreCustomFields"])
                    this.coreCustomFields!.push(CustomField.fromJS(item));
            }
            if (Array.isArray(_data["vitalsMCustomFields"])) {
                this.vitalsMCustomFields = [] as any;
                for (let item of _data["vitalsMCustomFields"])
                    this.vitalsMCustomFields!.push(CustomField.fromJS(item));
            }
            if (Array.isArray(_data["assessmentCustomFields"])) {
                this.assessmentCustomFields = [] as any;
                for (let item of _data["assessmentCustomFields"])
                    this.assessmentCustomFields!.push(CustomField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Dataset {
        data = typeof data === 'object' ? data : {};
        let result = new Dataset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["careConfigurationVersionId"] = this.careConfigurationVersionId;
        data["clientCount"] = this.clientCount;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicleTypes)) {
            data["vehicleTypes"] = [];
            for (let item of this.vehicleTypes)
                data["vehicleTypes"].push(item.toJSON());
        }
        data["careConfigurationJSON"] = this.careConfigurationJSON;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["training"] = this.training;
        data["datasetPurposeTypeId"] = this.datasetPurposeTypeId;
        data["datasetPurpose"] = this.datasetPurpose ? this.datasetPurpose.toJSON() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["showClientFirstName"] = this.showClientFirstName;
        data["showClientLastName"] = this.showClientLastName;
        data["showClientParticipantId"] = this.showClientParticipantId;
        data["showClientBirthMonth"] = this.showClientBirthMonth;
        data["showClientBirthDay"] = this.showClientBirthDay;
        data["showClientAddress"] = this.showClientAddress;
        data["maxioSubscriptionId"] = this.maxioSubscriptionId;
        data["neurapulseApiKey"] = this.neurapulseApiKey;
        data["neurapulseProjectId"] = this.neurapulseProjectId;
        data["organizationId"] = this.organizationId;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["canCreateAssessment"] = this.canCreateAssessment;
        data["canEditCognitiveTest"] = this.canEditCognitiveTest;
        data["canViewCognitiveTest"] = this.canViewCognitiveTest;
        data["canEditOnRoadTest"] = this.canEditOnRoadTest;
        data["canViewOnRoadTest"] = this.canViewOnRoadTest;
        data["canViewAssessment"] = this.canViewAssessment;
        data["canCreateClient"] = this.canCreateClient;
        data["canViewClients"] = this.canViewClients;
        data["canViewDataset"] = this.canViewDataset;
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item.toJSON());
        }
        if (Array.isArray(this.clientCustomFields)) {
            data["clientCustomFields"] = [];
            for (let item of this.clientCustomFields)
                data["clientCustomFields"].push(item.toJSON());
        }
        if (Array.isArray(this.coreCustomFields)) {
            data["coreCustomFields"] = [];
            for (let item of this.coreCustomFields)
                data["coreCustomFields"].push(item.toJSON());
        }
        if (Array.isArray(this.vitalsMCustomFields)) {
            data["vitalsMCustomFields"] = [];
            for (let item of this.vitalsMCustomFields)
                data["vitalsMCustomFields"].push(item.toJSON());
        }
        if (Array.isArray(this.assessmentCustomFields)) {
            data["assessmentCustomFields"] = [];
            for (let item of this.assessmentCustomFields)
                data["assessmentCustomFields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDataset {
    id: number;
    name?: string | undefined;
    permissions?: string[] | undefined;
    careConfigurationVersionId: number;
    clientCount: number;
    locations?: Location[] | undefined;
    vehicleTypes?: PickList[] | undefined;
    careConfigurationJSON?: string | undefined;
    product?: Product | undefined;
    training: boolean;
    datasetPurposeTypeId: number;
    datasetPurpose?: DatasetPurposeType | undefined;
    modifiedOn?: Date | undefined;
    showClientFirstName: boolean;
    showClientLastName: boolean;
    showClientParticipantId: boolean;
    showClientBirthMonth: boolean;
    showClientBirthDay: boolean;
    showClientAddress: boolean;
    maxioSubscriptionId: number;
    neurapulseApiKey?: string | undefined;
    neurapulseProjectId?: string | undefined;
    organizationId: number;
    modules?: Module[] | undefined;
    canCreateAssessment: boolean;
    canEditCognitiveTest: boolean;
    canViewCognitiveTest: boolean;
    canEditOnRoadTest: boolean;
    canViewOnRoadTest: boolean;
    canViewAssessment: boolean;
    canCreateClient: boolean;
    canViewClients: boolean;
    canViewDataset: boolean;
    customFields?: CustomField[] | undefined;
    clientCustomFields?: CustomField[] | undefined;
    coreCustomFields?: CustomField[] | undefined;
    vitalsMCustomFields?: CustomField[] | undefined;
    assessmentCustomFields?: CustomField[] | undefined;
}

export class Location implements ILocation {
    id!: number;
    name?: string | undefined;
    isActive!: boolean;
    address1?: string | undefined;
    address2?: string | undefined;
    countryId?: number | undefined;
    provinceId?: number | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    postalCode?: string | undefined;
    courses?: Course[] | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.countryId = _data["countryId"];
            this.provinceId = _data["provinceId"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.postalCode = _data["postalCode"];
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(Course.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["countryId"] = this.countryId;
        data["provinceId"] = this.provinceId;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["postalCode"] = this.postalCode;
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocation {
    id: number;
    name?: string | undefined;
    isActive: boolean;
    address1?: string | undefined;
    address2?: string | undefined;
    countryId?: number | undefined;
    provinceId?: number | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    postalCode?: string | undefined;
    courses?: Course[] | undefined;
}

export class Course implements ICourse {
    id!: number;
    name?: string | undefined;
    isActive!: boolean;
    description?: string | undefined;
    courseFile?: string | undefined;

    constructor(data?: ICourse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.description = _data["description"];
            this.courseFile = _data["courseFile"];
        }
    }

    static fromJS(data: any): Course {
        data = typeof data === 'object' ? data : {};
        let result = new Course();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["courseFile"] = this.courseFile;
        return data;
    }
}

export interface ICourse {
    id: number;
    name?: string | undefined;
    isActive: boolean;
    description?: string | undefined;
    courseFile?: string | undefined;
}

export class PickList implements IPickList {
    id!: number;
    pickListTypeId!: number;
    code?: string | undefined;
    description?: string | undefined;
    parentId?: number | undefined;
    isDefault!: boolean;
    isActive!: boolean;

    constructor(data?: IPickList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pickListTypeId = _data["pickListTypeId"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.parentId = _data["parentId"];
            this.isDefault = _data["isDefault"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PickList {
        data = typeof data === 'object' ? data : {};
        let result = new PickList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pickListTypeId"] = this.pickListTypeId;
        data["code"] = this.code;
        data["description"] = this.description;
        data["parentId"] = this.parentId;
        data["isDefault"] = this.isDefault;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPickList {
    id: number;
    pickListTypeId: number;
    code?: string | undefined;
    description?: string | undefined;
    parentId?: number | undefined;
    isDefault: boolean;
    isActive: boolean;
}

export class Product implements IProduct {
    id!: number;
    name?: string | undefined;
    description?: string | undefined;
    reportTemplate?: string | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.reportTemplate = _data["reportTemplate"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["reportTemplate"] = this.reportTemplate;
        return data;
    }
}

export interface IProduct {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    reportTemplate?: string | undefined;
}

export class DatasetPurposeType implements IDatasetPurposeType {
    id!: number;
    name?: string | undefined;
    billing!: boolean;
    score!: boolean;
    report!: boolean;
    trainingData!: boolean;
    watermark!: boolean;

    constructor(data?: IDatasetPurposeType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.billing = _data["billing"];
            this.score = _data["score"];
            this.report = _data["report"];
            this.trainingData = _data["trainingData"];
            this.watermark = _data["watermark"];
        }
    }

    static fromJS(data: any): DatasetPurposeType {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetPurposeType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["billing"] = this.billing;
        data["score"] = this.score;
        data["report"] = this.report;
        data["trainingData"] = this.trainingData;
        data["watermark"] = this.watermark;
        return data;
    }
}

export interface IDatasetPurposeType {
    id: number;
    name?: string | undefined;
    billing: boolean;
    score: boolean;
    report: boolean;
    trainingData: boolean;
    watermark: boolean;
}

export class Module implements IModule {
    id!: number;
    name?: string | undefined;
    certRequired!: boolean;
    relatedPermissionCode?: string | undefined;
    ordinal!: number;
    required?: boolean | undefined;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.certRequired = _data["certRequired"];
            this.relatedPermissionCode = _data["relatedPermissionCode"];
            this.ordinal = _data["ordinal"];
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["certRequired"] = this.certRequired;
        data["relatedPermissionCode"] = this.relatedPermissionCode;
        data["ordinal"] = this.ordinal;
        data["required"] = this.required;
        return data;
    }
}

export interface IModule {
    id: number;
    name?: string | undefined;
    certRequired: boolean;
    relatedPermissionCode?: string | undefined;
    ordinal: number;
    required?: boolean | undefined;
}

export class FleetError implements IFleetError {
    id!: number;
    errorCode?: string | undefined;
    skillCategory!: number;
    errorCategory?: string | undefined;
    maxAllowed!: number;
    lastModified?: string | undefined;
    points!: number;
    isActive!: boolean;
    description?: string | undefined;
    vehicleType?: number | undefined;
    version!: number;
    lastModifiedOn!: Date;

    constructor(data?: IFleetError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.errorCode = _data["errorCode"];
            this.skillCategory = _data["skillCategory"];
            this.errorCategory = _data["errorCategory"];
            this.maxAllowed = _data["maxAllowed"];
            this.lastModified = _data["lastModified"];
            this.points = _data["points"];
            this.isActive = _data["isActive"];
            this.description = _data["description"];
            this.vehicleType = _data["vehicleType"];
            this.version = _data["version"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetError {
        data = typeof data === 'object' ? data : {};
        let result = new FleetError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["errorCode"] = this.errorCode;
        data["skillCategory"] = this.skillCategory;
        data["errorCategory"] = this.errorCategory;
        data["maxAllowed"] = this.maxAllowed;
        data["lastModified"] = this.lastModified;
        data["points"] = this.points;
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["vehicleType"] = this.vehicleType;
        data["version"] = this.version;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFleetError {
    id: number;
    errorCode?: string | undefined;
    skillCategory: number;
    errorCategory?: string | undefined;
    maxAllowed: number;
    lastModified?: string | undefined;
    points: number;
    isActive: boolean;
    description?: string | undefined;
    vehicleType?: number | undefined;
    version: number;
    lastModifiedOn: Date;
}

export class ImpiricaUser implements IImpiricaUser {
    id!: number;
    tenantId?: number | undefined;
    azureObjectId?: string | undefined;
    lastModifiedBy?: string | undefined;
    rolesList?: string | undefined;
    datasetRolesList?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActive!: boolean;
    email?: string | undefined;

    constructor(data?: IImpiricaUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.azureObjectId = _data["azureObjectId"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.rolesList = _data["rolesList"];
            this.datasetRolesList = _data["datasetRolesList"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isActive = _data["isActive"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ImpiricaUser {
        data = typeof data === 'object' ? data : {};
        let result = new ImpiricaUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["azureObjectId"] = this.azureObjectId;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["rolesList"] = this.rolesList;
        data["datasetRolesList"] = this.datasetRolesList;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isActive"] = this.isActive;
        data["email"] = this.email;
        return data;
    }
}

export interface IImpiricaUser {
    id: number;
    tenantId?: number | undefined;
    azureObjectId?: string | undefined;
    lastModifiedBy?: string | undefined;
    rolesList?: string | undefined;
    datasetRolesList?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActive: boolean;
    email?: string | undefined;
}

export class ImpiricaUserDetails implements IImpiricaUserDetails {
    id!: number;
    vitalsCertificationId!: number;
    coreCertificationId!: number;
    careCertificationId!: number;
    dcatCertificationId!: number;
    doreCertificationId!: number;
    exceleRATEUser!: boolean;
    driveABLEUser!: boolean;

    constructor(data?: IImpiricaUserDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vitalsCertificationId = _data["vitalsCertificationId"];
            this.coreCertificationId = _data["coreCertificationId"];
            this.careCertificationId = _data["careCertificationId"];
            this.dcatCertificationId = _data["dcatCertificationId"];
            this.doreCertificationId = _data["doreCertificationId"];
            this.exceleRATEUser = _data["exceleRATEUser"];
            this.driveABLEUser = _data["driveABLEUser"];
        }
    }

    static fromJS(data: any): ImpiricaUserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ImpiricaUserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vitalsCertificationId"] = this.vitalsCertificationId;
        data["coreCertificationId"] = this.coreCertificationId;
        data["careCertificationId"] = this.careCertificationId;
        data["dcatCertificationId"] = this.dcatCertificationId;
        data["doreCertificationId"] = this.doreCertificationId;
        data["exceleRATEUser"] = this.exceleRATEUser;
        data["driveABLEUser"] = this.driveABLEUser;
        return data;
    }
}

export interface IImpiricaUserDetails {
    id: number;
    vitalsCertificationId: number;
    coreCertificationId: number;
    careCertificationId: number;
    dcatCertificationId: number;
    doreCertificationId: number;
    exceleRATEUser: boolean;
    driveABLEUser: boolean;
}

export class LoginHistory implements ILoginHistory {
    id!: number;
    userId!: number;
    timestamp!: Date;
    telemetry?: string | undefined;
    platform?: string | undefined;

    constructor(data?: ILoginHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.telemetry = _data["telemetry"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): LoginHistory {
        data = typeof data === 'object' ? data : {};
        let result = new LoginHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["telemetry"] = this.telemetry;
        data["platform"] = this.platform;
        return data;
    }
}

export interface ILoginHistory {
    id: number;
    userId: number;
    timestamp: Date;
    telemetry?: string | undefined;
    platform?: string | undefined;
}

export class Language implements ILanguage {
    lcid!: number;
    code?: string | undefined;
    displayName?: string | undefined;
    englishName?: string | undefined;

    constructor(data?: ILanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lcid = _data["lcid"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.englishName = _data["englishName"];
        }
    }

    static fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lcid"] = this.lcid;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["englishName"] = this.englishName;
        return data;
    }
}

export interface ILanguage {
    lcid: number;
    code?: string | undefined;
    displayName?: string | undefined;
    englishName?: string | undefined;
}

export class CoreRouteError implements ICoreRouteError {
    route?: CoreTestRoute[] | undefined;
    errors?: CoreErrorEntryListItems[] | undefined;

    constructor(data?: ICoreRouteError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["route"])) {
                this.route = [] as any;
                for (let item of _data["route"])
                    this.route!.push(CoreTestRoute.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(CoreErrorEntryListItems.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoreRouteError {
        data = typeof data === 'object' ? data : {};
        let result = new CoreRouteError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.route)) {
            data["route"] = [];
            for (let item of this.route)
                data["route"].push(item.toJSON());
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICoreRouteError {
    route?: CoreTestRoute[] | undefined;
    errors?: CoreErrorEntryListItems[] | undefined;
}

export class MobileDiagnostics implements IMobileDiagnostics {
    id!: number;
    payloads?: string | undefined;
    appStorage?: string | undefined;
    logs?: string | undefined;
    userId?: number | undefined;
    timestamp?: Date | undefined;

    constructor(data?: IMobileDiagnostics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payloads = _data["payloads"];
            this.appStorage = _data["appStorage"];
            this.logs = _data["logs"];
            this.userId = _data["userId"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MobileDiagnostics {
        data = typeof data === 'object' ? data : {};
        let result = new MobileDiagnostics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payloads"] = this.payloads;
        data["appStorage"] = this.appStorage;
        data["logs"] = this.logs;
        data["userId"] = this.userId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMobileDiagnostics {
    id: number;
    payloads?: string | undefined;
    appStorage?: string | undefined;
    logs?: string | undefined;
    userId?: number | undefined;
    timestamp?: Date | undefined;
}

export class DatasetModules implements IDatasetModules {
    datasetId!: number;
    modules?: Module[] | undefined;

    constructor(data?: IDatasetModules) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datasetId = _data["datasetId"];
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(Module.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DatasetModules {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetModules();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasetId"] = this.datasetId;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDatasetModules {
    datasetId: number;
    modules?: Module[] | undefined;
}

export class Vw_ModuleUserPermissions implements IVw_ModuleUserPermissions {
    moduleId!: number;
    datasetId!: number;
    userId!: number;
    canEdit!: boolean;
    ordinal!: number;

    constructor(data?: IVw_ModuleUserPermissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["moduleId"];
            this.datasetId = _data["datasetId"];
            this.userId = _data["userId"];
            this.canEdit = _data["canEdit"];
            this.ordinal = _data["ordinal"];
        }
    }

    static fromJS(data: any): Vw_ModuleUserPermissions {
        data = typeof data === 'object' ? data : {};
        let result = new Vw_ModuleUserPermissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleId"] = this.moduleId;
        data["datasetId"] = this.datasetId;
        data["userId"] = this.userId;
        data["canEdit"] = this.canEdit;
        data["ordinal"] = this.ordinal;
        return data;
    }
}

export interface IVw_ModuleUserPermissions {
    moduleId: number;
    datasetId: number;
    userId: number;
    canEdit: boolean;
    ordinal: number;
}

export class ModuleDatasetXRef implements IModuleDatasetXRef {
    moduleId!: number;
    datasetId!: number;

    constructor(data?: IModuleDatasetXRef) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["moduleId"];
            this.datasetId = _data["datasetId"];
        }
    }

    static fromJS(data: any): ModuleDatasetXRef {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleDatasetXRef();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleId"] = this.moduleId;
        data["datasetId"] = this.datasetId;
        return data;
    }
}

export interface IModuleDatasetXRef {
    moduleId: number;
    datasetId: number;
}

export class Organization implements IOrganization {
    id!: number;
    name?: string | undefined;
    isActive!: boolean;
    webIdPrefix!: number;
    logoUrl?: string | undefined;
    automaticClientRedaction!: AutoRedactionState;
    automaticDataLock!: boolean;
    maximumDaysUntilRedaction?: number | undefined;
    maximumDaysUntilCoreLocked?: number | undefined;
    maximumDaysUntilVitalsLocked?: number | undefined;
    isDefault!: boolean;
    redacted!: boolean;
    daysUntilLock!: number;
    showCommDrivingExp!: boolean;
    requireCommDrivingExp!: boolean;
    isPrimaryOrg!: boolean;
    datasetCount!: number;
    modules?: Module[] | undefined;

    constructor(data?: IOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.webIdPrefix = _data["webIdPrefix"];
            this.logoUrl = _data["logoUrl"];
            this.automaticClientRedaction = _data["automaticClientRedaction"];
            this.automaticDataLock = _data["automaticDataLock"];
            this.maximumDaysUntilRedaction = _data["maximumDaysUntilRedaction"];
            this.maximumDaysUntilCoreLocked = _data["maximumDaysUntilCoreLocked"];
            this.maximumDaysUntilVitalsLocked = _data["maximumDaysUntilVitalsLocked"];
            this.isDefault = _data["isDefault"];
            this.redacted = _data["redacted"];
            this.daysUntilLock = _data["daysUntilLock"];
            this.showCommDrivingExp = _data["showCommDrivingExp"];
            this.requireCommDrivingExp = _data["requireCommDrivingExp"];
            this.isPrimaryOrg = _data["isPrimaryOrg"];
            this.datasetCount = _data["datasetCount"];
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(Module.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Organization {
        data = typeof data === 'object' ? data : {};
        let result = new Organization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["webIdPrefix"] = this.webIdPrefix;
        data["logoUrl"] = this.logoUrl;
        data["automaticClientRedaction"] = this.automaticClientRedaction;
        data["automaticDataLock"] = this.automaticDataLock;
        data["maximumDaysUntilRedaction"] = this.maximumDaysUntilRedaction;
        data["maximumDaysUntilCoreLocked"] = this.maximumDaysUntilCoreLocked;
        data["maximumDaysUntilVitalsLocked"] = this.maximumDaysUntilVitalsLocked;
        data["isDefault"] = this.isDefault;
        data["redacted"] = this.redacted;
        data["daysUntilLock"] = this.daysUntilLock;
        data["showCommDrivingExp"] = this.showCommDrivingExp;
        data["requireCommDrivingExp"] = this.requireCommDrivingExp;
        data["isPrimaryOrg"] = this.isPrimaryOrg;
        data["datasetCount"] = this.datasetCount;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganization {
    id: number;
    name?: string | undefined;
    isActive: boolean;
    webIdPrefix: number;
    logoUrl?: string | undefined;
    automaticClientRedaction: AutoRedactionState;
    automaticDataLock: boolean;
    maximumDaysUntilRedaction?: number | undefined;
    maximumDaysUntilCoreLocked?: number | undefined;
    maximumDaysUntilVitalsLocked?: number | undefined;
    isDefault: boolean;
    redacted: boolean;
    daysUntilLock: number;
    showCommDrivingExp: boolean;
    requireCommDrivingExp: boolean;
    isPrimaryOrg: boolean;
    datasetCount: number;
    modules?: Module[] | undefined;
}

export enum AutoRedactionState {
    None = 0,
    Timed = 1,
    Inherit = 2,
}

export class OrgXRefUser implements IOrgXRefUser {
    organizationId!: number;
    impiricaUserId!: number;
    primaryOrg!: boolean;
    dateModified!: Date;
    name?: string | undefined;
    isActive!: boolean;

    constructor(data?: IOrgXRefUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.impiricaUserId = _data["impiricaUserId"];
            this.primaryOrg = _data["primaryOrg"];
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): OrgXRefUser {
        data = typeof data === 'object' ? data : {};
        let result = new OrgXRefUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["impiricaUserId"] = this.impiricaUserId;
        data["primaryOrg"] = this.primaryOrg;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IOrgXRefUser {
    organizationId: number;
    impiricaUserId: number;
    primaryOrg: boolean;
    dateModified: Date;
    name?: string | undefined;
    isActive: boolean;
}

export class TripTask implements ITripTask {
    id!: number;
    name?: string | undefined;
    ordinal!: number;

    constructor(data?: ITripTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ordinal = _data["ordinal"];
        }
    }

    static fromJS(data: any): TripTask {
        data = typeof data === 'object' ? data : {};
        let result = new TripTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ordinal"] = this.ordinal;
        return data;
    }
}

export interface ITripTask {
    id: number;
    name?: string | undefined;
    ordinal: number;
}

export class TripTaskVehicleType implements ITripTaskVehicleType {
    tripTaskId!: number;
    vehicleSubTypeId!: number;

    constructor(data?: ITripTaskVehicleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripTaskId = _data["tripTaskId"];
            this.vehicleSubTypeId = _data["vehicleSubTypeId"];
        }
    }

    static fromJS(data: any): TripTaskVehicleType {
        data = typeof data === 'object' ? data : {};
        let result = new TripTaskVehicleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripTaskId"] = this.tripTaskId;
        data["vehicleSubTypeId"] = this.vehicleSubTypeId;
        return data;
    }
}

export interface ITripTaskVehicleType {
    tripTaskId: number;
    vehicleSubTypeId: number;
}

export class TripObservationType implements ITripObservationType {
    id!: number;
    tripTaskId!: number;
    name?: string | undefined;
    description?: string | undefined;
    ordinal!: number;
    tripObservationDetails?: TripObservationTypeDetail[] | undefined;

    constructor(data?: ITripObservationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tripTaskId = _data["tripTaskId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.ordinal = _data["ordinal"];
            if (Array.isArray(_data["tripObservationDetails"])) {
                this.tripObservationDetails = [] as any;
                for (let item of _data["tripObservationDetails"])
                    this.tripObservationDetails!.push(TripObservationTypeDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TripObservationType {
        data = typeof data === 'object' ? data : {};
        let result = new TripObservationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tripTaskId"] = this.tripTaskId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["ordinal"] = this.ordinal;
        if (Array.isArray(this.tripObservationDetails)) {
            data["tripObservationDetails"] = [];
            for (let item of this.tripObservationDetails)
                data["tripObservationDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITripObservationType {
    id: number;
    tripTaskId: number;
    name?: string | undefined;
    description?: string | undefined;
    ordinal: number;
    tripObservationDetails?: TripObservationTypeDetail[] | undefined;
}

export class TripObservationTypeDetail implements ITripObservationTypeDetail {
    id!: number;
    tripObservationTypeId!: number;
    description?: string | undefined;
    ordinal!: number;

    constructor(data?: ITripObservationTypeDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tripObservationTypeId = _data["tripObservationTypeId"];
            this.description = _data["description"];
            this.ordinal = _data["ordinal"];
        }
    }

    static fromJS(data: any): TripObservationTypeDetail {
        data = typeof data === 'object' ? data : {};
        let result = new TripObservationTypeDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tripObservationTypeId"] = this.tripObservationTypeId;
        data["description"] = this.description;
        data["ordinal"] = this.ordinal;
        return data;
    }
}

export interface ITripObservationTypeDetail {
    id: number;
    tripObservationTypeId: number;
    description?: string | undefined;
    ordinal: number;
}

export class TripObservationTypeVehicleType implements ITripObservationTypeVehicleType {
    tripObservationTypeId!: number;
    vehicleSubTypeId!: number;

    constructor(data?: ITripObservationTypeVehicleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripObservationTypeId = _data["tripObservationTypeId"];
            this.vehicleSubTypeId = _data["vehicleSubTypeId"];
        }
    }

    static fromJS(data: any): TripObservationTypeVehicleType {
        data = typeof data === 'object' ? data : {};
        let result = new TripObservationTypeVehicleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripObservationTypeId"] = this.tripObservationTypeId;
        data["vehicleSubTypeId"] = this.vehicleSubTypeId;
        return data;
    }
}

export interface ITripObservationTypeVehicleType {
    tripObservationTypeId: number;
    vehicleSubTypeId: number;
}

export class VehicleSubType implements IVehicleSubType {
    id!: number;
    vehicleTypeId!: number;
    description?: string | undefined;

    constructor(data?: IVehicleSubType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): VehicleSubType {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleSubType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["description"] = this.description;
        return data;
    }
}

export interface IVehicleSubType {
    id: number;
    vehicleTypeId: number;
    description?: string | undefined;
}

export class NeurapulseConfiguration implements INeurapulseConfiguration {
    apiKey?: string | undefined;
    projectId?: string | undefined;

    constructor(data?: INeurapulseConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): NeurapulseConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new NeurapulseConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface INeurapulseConfiguration {
    apiKey?: string | undefined;
    projectId?: string | undefined;
}

export class NeurapulseProject implements INeurapulseProject {
    id!: string;
    name?: string | undefined;
    fitForDutyResponse?: string | undefined;
    state!: ActiveStateType;
    dateCreated!: Date;

    constructor(data?: INeurapulseProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fitForDutyResponse = _data["fitForDutyResponse"];
            this.state = _data["state"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NeurapulseProject {
        data = typeof data === 'object' ? data : {};
        let result = new NeurapulseProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fitForDutyResponse"] = this.fitForDutyResponse;
        data["state"] = this.state;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        return data;
    }
}

export interface INeurapulseProject {
    id: string;
    name?: string | undefined;
    fitForDutyResponse?: string | undefined;
    state: ActiveStateType;
    dateCreated: Date;
}

export enum ActiveStateType {
    Draft = "Draft",
    Active = "Active",
    Inactive = "Inactive",
    Deleted = "Deleted",
    ActiveExpired = "ActiveExpired",
}

export class NeurapulseGetProjects implements INeurapulseGetProjects {
    apiKey?: string | undefined;

    constructor(data?: INeurapulseGetProjects) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
        }
    }

    static fromJS(data: any): NeurapulseGetProjects {
        data = typeof data === 'object' ? data : {};
        let result = new NeurapulseGetProjects();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        return data;
    }
}

export interface INeurapulseGetProjects {
    apiKey?: string | undefined;
}

export class NeurapulseTestApiKey implements INeurapulseTestApiKey {
    apiKey?: string | undefined;
    organizationId!: number;
    datasetId!: number;

    constructor(data?: INeurapulseTestApiKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.organizationId = _data["organizationId"];
            this.datasetId = _data["datasetId"];
        }
    }

    static fromJS(data: any): NeurapulseTestApiKey {
        data = typeof data === 'object' ? data : {};
        let result = new NeurapulseTestApiKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["organizationId"] = this.organizationId;
        data["datasetId"] = this.datasetId;
        return data;
    }
}

export interface INeurapulseTestApiKey {
    apiKey?: string | undefined;
    organizationId: number;
    datasetId: number;
}

export class NeurapulseImportProgress implements INeurapulseImportProgress {
    percentageComplete!: number;
    success!: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    errorMessage?: string | undefined;

    constructor(data?: INeurapulseImportProgress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentageComplete = _data["percentageComplete"];
            this.success = _data["success"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): NeurapulseImportProgress {
        data = typeof data === 'object' ? data : {};
        let result = new NeurapulseImportProgress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentageComplete"] = this.percentageComplete;
        data["success"] = this.success;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface INeurapulseImportProgress {
    percentageComplete: number;
    success: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    errorMessage?: string | undefined;
}

export class ImportNeurapulseTestTakersByEmailRequest implements IImportNeurapulseTestTakersByEmailRequest {
    emailAddresses?: string[] | undefined;

    constructor(data?: IImportNeurapulseTestTakersByEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emailAddresses"])) {
                this.emailAddresses = [] as any;
                for (let item of _data["emailAddresses"])
                    this.emailAddresses!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportNeurapulseTestTakersByEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportNeurapulseTestTakersByEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emailAddresses)) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item);
        }
        return data;
    }
}

export interface IImportNeurapulseTestTakersByEmailRequest {
    emailAddresses?: string[] | undefined;
}

export class NeurapulseTestTaker implements INeurapulseTestTaker {
    id!: number;
    referenceId?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    yearOfBirth!: number;
    result?: string | undefined;
    dateCompleted?: Date | undefined;

    constructor(data?: INeurapulseTestTaker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceId = _data["referenceId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.yearOfBirth = _data["yearOfBirth"];
            this.result = _data["result"];
            this.dateCompleted = _data["dateCompleted"] ? new Date(_data["dateCompleted"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NeurapulseTestTaker {
        data = typeof data === 'object' ? data : {};
        let result = new NeurapulseTestTaker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceId"] = this.referenceId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["yearOfBirth"] = this.yearOfBirth;
        data["result"] = this.result;
        data["dateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : <any>undefined;
        return data;
    }
}

export interface INeurapulseTestTaker {
    id: number;
    referenceId?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    yearOfBirth: number;
    result?: string | undefined;
    dateCompleted?: Date | undefined;
}

export class Results implements IResults {

    [key: string]: any;

    constructor(data?: IResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Results {
        data = typeof data === 'object' ? data : {};
        let result = new Results();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IResults {

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}